/* Product card CSS overrides — injected via JS to bypass Shopify CDN compiled cache */
(function(){var s=document.createElement('style');s.textContent='.product-card{min-width:0;display:flex!important;flex-direction:column;height:100%;gap:0;align-content:start;background:rgba(255,255,255,0.6);border:none;border-radius:10px;box-shadow:0 6px 16px rgba(0,0,0,0.03);overflow:hidden;backdrop-filter:blur(4px)}.product-card__media{display:block;position:relative;aspect-ratio:4/5!important;overflow:hidden;border:0;border-radius:8px;background:#f8f8f8;margin-bottom:0}.product-card__info{padding:12px;display:flex;flex-direction:column;flex:1}.product-card__media img,.product-card__media svg,.product-card__media video{object-fit:contain!important;object-position:center;border-radius:8px}.product-card__media-slide{position:relative;display:grid;place-items:center;flex:0 0 100%;width:100%;height:100%;scroll-snap-align:start;scroll-snap-stop:always;overflow:hidden;background:#f8f8f8}.product-card__media img,.product-card__media svg,.product-card__media video,.product-card__video-wrap{width:100%;height:100%}.product-card__video-wrap{position:relative;display:block;background:#111;border-radius:8px;overflow:hidden}';document.head.appendChild(s);})();
(function () {
  const selectors = {
    drawerTrigger: '[data-drawer-trigger]',
    drawerClose: '[data-drawer-close]',
    backdrop: '[data-drawer-backdrop]',
    cartCount: '[data-cart-count]',
    toastRegion: '[data-toast-region]'
  };

  let activeDrawer = null;
  let activeLightbox = null;
  let lastFocused = null;
  let pushedDrawerId = null;

  function getFocusable(container) {
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
  }

  function openDrawer(id, fromPopState = false) {
    const drawer = document.getElementById(id);
    const backdrop = document.querySelector(selectors.backdrop);
    if (!drawer) return;
    lastFocused = document.activeElement;
    activeDrawer = drawer;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop && backdrop.classList.add('is-open');
    document.body.classList.add('is-locked');
    document.querySelectorAll(`[aria-controls="${id}"]`).forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));

    if (!fromPopState && window.history && window.history.pushState) {
      if (!pushedDrawerId) {
        pushedDrawerId = id;
        const hash = '#' + id.toLowerCase();
        window.history.pushState({ drawer: id }, '', window.location.pathname + window.location.search + hash);
      }
    }

    const focusable = getFocusable(drawer);
    (focusable[0] || drawer).focus();
    if (id === 'SearchDrawer') {
      shuffleSearchBrands();
      window.setTimeout(() => drawer.querySelector('input[type="search"]')?.focus(), 80);
    }
    if (id === 'CollectionFilterDrawer' || id === 'SearchFilterDrawer') {
      if (typeof window.rwRefreshFilters === 'function') {
        window.rwRefreshFilters();
      }
    }
    if (id === 'CartDrawer') {
      document.querySelectorAll('.mobile-bottom-nav button[aria-controls="CartDrawer"]').forEach((button) => button.classList.add('is-active'));
    }
  }

  function closeDrawer(fromPopState = false, skipHistoryBack = false) {
    if (!activeDrawer) return;
    const id = activeDrawer.id;
    activeDrawer.classList.remove('is-open');
    activeDrawer.setAttribute('aria-hidden', 'true');
    document.querySelector(selectors.backdrop)?.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    document.querySelectorAll(`[aria-controls="${id}"]`).forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (id === 'CartDrawer') {
      document.querySelectorAll('.mobile-bottom-nav button[aria-controls="CartDrawer"]:not([aria-current="page"])').forEach((button) => button.classList.remove('is-active'));
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    activeDrawer = null;

    if (!fromPopState && pushedDrawerId === id) {
      pushedDrawerId = null;
      if (!skipHistoryBack && window.location.hash.toLowerCase() === '#' + id.toLowerCase()) {
        window.history.back();
      }
    } else {
      pushedDrawerId = null;
    }
  }

  function isSamePageAnchor(link) {
    if (!link || !link.hash) return false;
    const url = new URL(link.href, window.location.href);
    return url.pathname === window.location.pathname && url.origin === window.location.origin;
  }

  function trapFocus(event) {
    if (!activeDrawer || event.key !== 'Tab') return;
    const focusable = getFocusable(activeDrawer);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function toast(message, isError) {
    const region = document.querySelector(selectors.toastRegion);
    if (!region) return;
    const item = document.createElement('div');
    item.className = 'toast';
    item.textContent = message;
    if (isError) item.style.background = 'var(--color-error)';
    region.appendChild(item);
    window.setTimeout(() => item.remove(), 3600);
  }
  const showToast = toast;
  window.showToast = toast;

  async function shareProduct(button) {
    const title = button.dataset.shareTitle || document.title;
    const url = button.dataset.shareUrl || window.location.href;
    const text = `Check this product: ${title}`;
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url });
        return;
      }
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement('input');
        input.value = url;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      toast('Product link copied');
    } catch (error) {
      if (error?.name === 'AbortError') return;
      toast('Could not share this product', true);
    }
  }

  async function shareCurrentView() {
    let url = window.location.href;
    try {
      const urlObj = new URL(window.location.href);
      const drawerHashes = ['#mobilemenudrawer', '#searchdrawer', '#cartdrawer', '#collectionfilterdrawer', '#searchfilterdrawer', '#filterdrawer'];
      if (drawerHashes.includes(urlObj.hash.toLowerCase())) {
        urlObj.hash = '';
      }
      url = urlObj.toString();
    } catch (e) {
      url = window.location.href.split('#')[0];
    }

    const title = document.title || 'R WATCHES NGP';
    const text = document.title ? `Check out: ${document.title}` : 'Check out R Watches NGP';

    // 1. Copy URL to clipboard
    let copied = false;
    if (navigator.clipboard && window.isSecureContext && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        copied = true;
      } catch (err) {
        copied = false;
      }
    }
    if (!copied) {
      try {
        const input = document.createElement('input');
        input.value = url;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        copied = document.execCommand('copy');
        input.remove();
      } catch (err) {}
    }

    // 2. Show toast message
    toast('Link copied successfully.');

    // Close menu drawer if open
    if (activeDrawer && activeDrawer.id === 'MobileMenuDrawer') {
      closeDrawer();
    }

    // 3. Open native device share sheet if available
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url
        });
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }
  }
  window.shareCurrentView = shareCurrentView;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function cartToast(item) {
    const region = document.querySelector(selectors.toastRegion);
    if (!region) return;
    const toastItem = document.createElement('div');
    toastItem.className = 'cart-toast';
    const image = item.image || item.featured_image?.url || '';
    const title = item.product_title || item.title || 'Added to cart';
    toastItem.innerHTML = `
      ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}">` : '<span></span>'}
      <div>
        <strong>${escapeHtml(title)}</strong>
        <button type="button" class="cart-toast__checkout" data-drawer-trigger="CartDrawer" aria-controls="CartDrawer">View Bag</button>
      </div>
    `;
    region.appendChild(toastItem);
    window.setTimeout(() => toastItem.remove(), 6000);
  }

  let adminProductsCache = null;

  function loadStoreAdminProducts() {
    if (adminProductsCache && adminProductsCache.length) return adminProductsCache;
    const seen = new Set();
    const products = [];
    const add = (title, image, url) => {
      const cleanTitle = String(title || '').trim();
      let cleanImage = String(image || '').trim();
      if (!cleanTitle || !cleanImage || seen.has(cleanTitle.toLowerCase())) return;
      if (cleanImage.startsWith('//')) cleanImage = 'https:' + cleanImage;
      seen.add(cleanTitle.toLowerCase());
      products.push({ title: cleanTitle, image: cleanImage, url: url || window.location.href });
    };

    // 1. Read admin products directly injected from Liquid
    try {
      const scriptEl = document.getElementById('rw-admin-flash-products');
      if (scriptEl) {
        const list = JSON.parse(scriptEl.textContent || '[]');
        if (Array.isArray(list)) {
          list.forEach((p) => {
            if (p && p.title && p.image) add(p.title, p.image, p.url);
          });
        }
      }
    } catch (_) {}

    // 2. Read from current product page if active
    const productTitle = document.querySelector('.product-title')?.textContent;
    const currentProductImage = document.querySelector('.product-media-panel.is-active img, .product-gallery img');
    const productImage = currentProductImage?.currentSrc || currentProductImage?.src || document.querySelector('meta[property="og:image"]')?.content;
    if (productTitle && productImage) {
      add(productTitle, productImage, window.location.href);
    }

    // 3. Read from product cards on the page (they have admin Shopify CDN URLs)
    document.querySelectorAll('.product-card').forEach((card) => {
      const titleLink = card.querySelector('.product-card__title a');
      const title = titleLink?.textContent;
      const cardImage = card.querySelector('.product-card__media img');
      const image = cardImage?.currentSrc || cardImage?.src || cardImage?.getAttribute('src');
      if (title && image && !image.includes('placeholder')) {
        add(title, image, titleLink?.href);
      }
    });

    adminProductsCache = products;
    return products;
  }

  function fetchLiveShopifyAdminProducts() {
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}products.json?limit=50`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data && Array.isArray(data.products) && data.products.length) {
          const seen = new Set((adminProductsCache || []).map((p) => p.title.toLowerCase()));
          const list = [...(adminProductsCache || [])];
          data.products.forEach((p) => {
            const title = String(p.title || '').trim();
            const img = p.images?.[0]?.src || p.image?.src;
            if (title && img && !seen.has(title.toLowerCase())) {
              seen.add(title.toLowerCase());
              const optimizedImg = img.includes('?') ? `${img}&width=240` : `${img}?width=240`;
              list.push({
                title,
                image: optimizedImg,
                url: safeProductUrl(p.handle)
              });
            }
          });
          if (list.length) {
            adminProductsCache = list;
          }
        }
      })
      .catch(() => {});
  }

  function triggerJustBookedFlash() {
    const region = document.querySelector(selectors.toastRegion);
    if (!region) return;
    const path = window.location.pathname;
    if (/\/(cart|account|checkouts?)/.test(path)) return;
    if (document.hidden) return;

    fetchLiveShopifyAdminProducts();
    const cities = ['Mumbai', 'Delhi', 'Bengaluru', 'Hyderabad', 'Pune', 'Chennai', 'Kolkata', 'Ahmedabad', 'Jaipur', 'Lucknow', 'Surat', 'Indore', 'Chandigarh', 'Nagpur'];
    const buyers = ['Rahul S.', 'Amit P.', 'Vikram K.', 'Rohan M.', 'Karan G.', 'Deepak S.', 'Siddharth N.', 'Aniket V.', 'Pooja R.', 'Neha K.', 'Sneha P.', 'Rajesh D.', 'Aditya B.', 'Vikas J.'];
    const times = ['Just now', '2 minutes ago', '3 minutes ago', '5 minutes ago', '7 minutes ago', '10 minutes ago', '14 minutes ago', '18 minutes ago'];
    const randomFrom = (items) => items[Math.floor(Math.random() * items.length)];

    const remove = (item) => {
      if (!item || item.classList.contains('is-leaving')) return;
      item.classList.add('is-leaving');
      window.setTimeout(() => item.remove(), 220);
    };

    region.querySelectorAll('.order-flash').forEach(remove);
    const products = loadStoreAdminProducts();
    if (!products.length) return;

    const product = randomFrom(products);
    const city = randomFrom(cities);
    const buyer = randomFrom(buyers);
    const timeAgo = randomFrom(times);
    const item = document.createElement('div');
    item.className = 'order-flash';
    item.setAttribute('role', 'status');
    item.innerHTML = `
      <a class="order-flash__link" href="${escapeHtml(product.url)}" aria-label="View ${escapeHtml(product.title)}">
        <div class="order-flash__media">
          <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="eager" width="56" height="56">
        </div>
        <div class="order-flash__center">
          <div class="order-flash__badge">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            <span>JUST BOOKED</span>
          </div>
          <strong class="order-flash__title">${escapeHtml(product.title)}</strong>
          <span class="order-flash__buyer">by ${escapeHtml(buyer)}</span>
        </div>
        <div class="order-flash__right">
          <span class="order-flash__location">${escapeHtml(city)}, India</span>
          <span class="order-flash__time">${escapeHtml(timeAgo)}</span>
        </div>
      </a>
      <button class="order-flash__close" type="button" aria-label="Hide order notification">&times;</button>
    `;
    item.querySelector('.order-flash__close')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      remove(item);
    });
    region.appendChild(item);
    window.setTimeout(() => remove(item), 4000); // stay for 4 seconds
  }

  function getOriginalImageUrl(url) {
    if (!url) return '';
    let str = String(url).trim();
    if (str.startsWith('//')) {
      str = 'https:' + str;
    }
    try {
      const parsed = new URL(str, typeof window !== 'undefined' ? (window.location.origin || 'https://cdn.shopify.com') : 'https://cdn.shopify.com');
      
      // Remove all Shopify downscaling, cropping, and formatting parameters
      parsed.searchParams.delete('width');
      parsed.searchParams.delete('height');
      parsed.searchParams.delete('crop');
      parsed.searchParams.delete('format');
      parsed.searchParams.delete('scale');

      // Remove legacy Shopify size suffixes before file extension (_480x480, _1024x1024_crop_center, _large, etc.)
      parsed.pathname = parsed.pathname
        .replace(/_([0-9]+x[0-9]*|pico|icon|thumb|small|compact|medium|large|grande|master)(_crop_[a-z]+)?/gi, '')
        .replace(/_crop_[a-z]+/gi, '');
        
      return parsed.toString();
    } catch (e) {
      return str
        .replace(/&?(width|height|crop|format|scale)=[^&]*/g, '')
        .replace(/_([0-9]+x[0-9]*|pico|icon|thumb|small|compact|medium|large|grande|master)(_crop_[a-z]+)?/gi, '')
        .replace(/_crop_[a-z]+/gi, '');
    }
  }

  async function triggerFileDownload(url, title, extension = 'jpg') {
    if (!url) return;
    const fullHdUrl = getOriginalImageUrl(url);
    const cleanTitle = (title || 'r-watches-full-hd').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    const filename = `${cleanTitle}-full-hd.${extension}`;

    // 1. Primary: Fetch master file as Blob with CORS and bypass browser thumbnail cache
    try {
      const fetchUrl = fullHdUrl + (fullHdUrl.includes('?') ? '&' : '?') + 'dl_ts=' + Date.now();
      const response = await fetch(fetchUrl, { mode: 'cors' });
      if (response.ok) {
        const blob = await response.blob();
        if (blob && blob.size > 200) {
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            if (a.parentNode) a.parentNode.removeChild(a);
            URL.revokeObjectURL(blobUrl);
          }, 3000);
          return;
        }
      }
    } catch (fetchErr) {
      console.warn('Direct master blob fetch failed, trying offscreen Image canvas...', fetchErr);
    }

    // 2. Secondary (for images): Load master image in offscreen Image with anonymous CORS and export full canvas
    if (extension !== 'mp4') {
      try {
        const masterImg = new Image();
        masterImg.crossOrigin = 'anonymous';
        const imgPromise = new Promise((resolve, reject) => {
          masterImg.onload = () => resolve(masterImg);
          masterImg.onerror = (err) => reject(err);
        });
        masterImg.src = fullHdUrl + (fullHdUrl.includes('?') ? '&' : '?') + 'dl_ts=' + Date.now();
        const loadedImg = await imgPromise;

        if (loadedImg.naturalWidth > 0 && loadedImg.naturalHeight > 0) {
          const canvas = document.createElement('canvas');
          canvas.width = loadedImg.naturalWidth;
          canvas.height = loadedImg.naturalHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(loadedImg, 0, 0);

          const blobPromise = new Promise((resolve) => {
            canvas.toBlob((b) => resolve(b), extension === 'png' ? 'image/png' : 'image/jpeg', 1.0);
          });
          const canvasBlob = await blobPromise;

          if (canvasBlob) {
            const blobUrl = URL.createObjectURL(canvasBlob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              if (a.parentNode) a.parentNode.removeChild(a);
              URL.revokeObjectURL(blobUrl);
            }, 3000);
            return;
          }
        }
      } catch (canvasErr) {
        console.warn('Offscreen master canvas fallback failed, falling back to direct link...', canvasErr);
      }
    }

    // 3. Fallback: Direct anchor download/open in new tab
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = fullHdUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { if (a.parentNode) a.parentNode.removeChild(a); }, 1500);
  }

  function productGalleryItems(gallery) {
    return Array.from(gallery.querySelectorAll('[data-product-media]')).map((panel) => {
      const image = panel.querySelector('img');
      const video = panel.querySelector('video');
      const title = image?.getAttribute('alt') || panel.dataset.productTitle || document.querySelector('.product-title')?.textContent || 'product-media';
      if (video) {
        const originalVideo = panel.dataset.originalVideo || video.dataset.originalVideo || video.dataset.src || video.querySelector('source')?.src || video.src || '';
        return {
          id: panel.dataset.productMedia,
          type: 'video',
          html: video.outerHTML,
          originalVideo: originalVideo,
          title: title,
          thumb: video.getAttribute('poster') || panel.querySelector('img')?.currentSrc || panel.querySelector('img')?.src || '',
          label: video.getAttribute('aria-label') || 'Product video'
        };
      }
      const rawSrc = image?.dataset.fullSrc || image?.currentSrc || image?.src || '';
      return {
        id: panel.dataset.productMedia,
        type: 'image',
        src: getOriginalImageUrl(rawSrc),
        title: title,
        thumb: image?.currentSrc || image?.src || image?.dataset.fullSrc || '',
        alt: image?.alt || document.querySelector('.product-title')?.textContent || 'Product image'
      };
    }).filter((item) => item.src || item.html);
  }

  let isLightboxStatePushed = false;

  function closeProductLightbox(fromPopState = false) {
    if (!activeLightbox) return;
    activeLightbox.element.remove();
    document.body.classList.remove('is-locked');
    activeLightbox.previousFocus?.focus?.();
    activeLightbox = null;

    if (!fromPopState && isLightboxStatePushed) {
      isLightboxStatePushed = false;
      if (window.location.hash === '#lightbox') {
        window.history.back();
      }
    } else {
      isLightboxStatePushed = false;
    }
  }

  function renderProductLightbox(index) {
    if (!activeLightbox) return;
    const total = activeLightbox.items.length;
    activeLightbox.index = (index + total) % total;
    const item = activeLightbox.items[activeLightbox.index];
    const media = activeLightbox.element.querySelector('[data-lightbox-media]');
    if (!media) return;
    media.innerHTML = item.type === 'video'
      ? item.html
      : `<img src="${escapeHtml(item.src)}" alt="${escapeHtml(item.alt)}">`;
    media.querySelector('video')?.setAttribute('controls', 'controls');
    media.querySelector('video')?.setAttribute('playsinline', 'playsinline');

    activeLightbox.element.querySelectorAll('[data-lightbox-direction]').forEach((button) => {
      button.hidden = total < 2;
    });
    activeLightbox.element.querySelectorAll('[data-lightbox-thumb]').forEach((button) => {
      button.toggleAttribute('aria-current', Number(button.dataset.lightboxThumb || 0) === activeLightbox.index);
    });
  }

  function openProductLightbox(gallery, mediaId) {
    const items = productGalleryItems(gallery);
    if (!items.length) return;
    const startIndex = Math.max(0, items.findIndex((item) => item.id === mediaId));
    closeProductLightbox();

    if (window.history && window.history.pushState && !isLightboxStatePushed) {
      isLightboxStatePushed = true;
      window.history.pushState({ modal: 'product-lightbox' }, '', window.location.pathname + window.location.search + '#lightbox');
    }

    const element = document.createElement('div');
    element.className = 'product-lightbox';
    element.setAttribute('role', 'dialog');
    element.setAttribute('aria-modal', 'true');
    element.setAttribute('aria-label', 'Product media preview');
    element.innerHTML = `
      <button class="product-lightbox__close" type="button" data-lightbox-close aria-label="Close product preview">&larr;</button>
      <button class="product-lightbox__nav product-lightbox__nav--prev" type="button" data-lightbox-direction="-1" aria-label="Previous product image">&lsaquo;</button>
      <div class="product-lightbox__stage" data-lightbox-media></div>
      <button class="product-lightbox__nav product-lightbox__nav--next" type="button" data-lightbox-direction="1" aria-label="Next product image">&rsaquo;</button>
      <div class="product-lightbox__thumbs" aria-label="Product preview thumbnails">
        ${items.map((item, itemIndex) => `
          <button class="product-lightbox__thumb" type="button" data-lightbox-thumb="${itemIndex}" aria-label="Show preview media ${itemIndex + 1}">
            ${item.thumb ? `<img src="${escapeHtml(item.thumb)}" alt="">` : '<span></span>'}
          </button>
        `).join('')}
      </div>
    `;
    document.body.appendChild(element);
    document.body.classList.add('is-locked');
    activeLightbox = {
      element,
      items,
      index: startIndex,
      previousFocus: document.activeElement
    };

    renderProductLightbox(startIndex);
    element.querySelector('[data-lightbox-close]')?.focus();
  }

  window.addEventListener('popstate', () => {
    if (activeDrawer) {
      closeDrawer(true);
      return;
    }
    if (activeLightbox) {
      closeProductLightbox(true);
      return;
    }
    const wbModal = document.getElementById('wb-reels-modal');
    if (wbModal && wbModal.style.display !== 'none' && wbModal.getAttribute('aria-hidden') !== 'true') {
      if (typeof closeWbModal === 'function') closeWbModal(true);
      return;
    }
    document.querySelectorAll('.media-options-modal').forEach(el => el.remove());
  });

  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '');
  }

  function canonicalSearchTerm(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\p{L}\p{N}]+/gu, '')
      .trim();
  }

  function canonicalTokens(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .split(/[^\p{L}\p{N}]+/gu)
      .filter(Boolean);
  }

  function resolveSearchBrand(rawQuery, collections) {
    if (!rawQuery) return null;
    const colList = Array.isArray(collections) && collections.length > 0
      ? collections
      : (Array.isArray(window.RW_LIVE_COLLECTIONS) ? window.RW_LIVE_COLLECTIONS : []);
    if (!colList.length) return null;
    const qClean = String(rawQuery).replace(/["*]/g, '').trim();
    const qCanon = canonicalSearchTerm(qClean);
    if (qCanon.length < 2) return null;

    const excludedHandles = new Set([
      'all', 'all-products', 'frontpage', 'catalog', 'video', 'click',
      'box-photo', 'og-box', 'custom', 'hd-video-all', 'live-data-girls',
      'click-data-girl-s', 'click-data-premium-1', 'click-auto-metal',
      'live-data-automatic-metal', 'live-data-leather-silicon', 'live-data-automatic-leather',
      'live-data-sporty', 'click-data-auto-leather', 'click-data-lether', 'click-data-sporty',
      'required-r3', 'required-r5', 'r-watches-ngp', 'r-watches', 'rwatches', 'ap', 'rm', 'ck', 'ax', 'lv'
    ]);

    const candidates = colList.filter(c => c && c.handle && !excludedHandles.has(c.handle) && Number(c.count || c.all_products_count || c.productsCount?.count || 0) > 0);

    // 1. Exact canonical match on collection title or handle
    for (let i = 0; i < candidates.length; i++) {
      const col = candidates[i];
      const cTitleCanon = canonicalSearchTerm(col.title);
      const cHandleCanon = canonicalSearchTerm(col.handle);
      if (qCanon === cTitleCanon || qCanon === cHandleCanon) {
        return {
          brand: col.title || col.handle,
          handle: col.handle,
          matchType: 'exact-canonical'
        };
      }
    }

    // 2. Unique prefix match: is query a prefix of a brand title/handle?
    if (qCanon.length >= 3) {
      const prefixMatches = [];
      for (let i = 0; i < candidates.length; i++) {
        const col = candidates[i];
        const cTitleCanon = canonicalSearchTerm(col.title);
        const cHandleCanon = canonicalSearchTerm(col.handle);
        if (cTitleCanon.startsWith(qCanon) || cHandleCanon.startsWith(qCanon)) {
          prefixMatches.push(col);
        }
      }
      if (prefixMatches.length === 1) {
        return {
          brand: prefixMatches[0].title || prefixMatches[0].handle,
          handle: prefixMatches[0].handle,
          matchType: 'unique-prefix'
        };
      }
    }

    return null;
  }

  function getProductTimestamp(p) {
    if (!p) return 0;
    let created = '';
    let updated = '';
    let published = '';
    let idStr = '';

    if (p instanceof Element || (p.dataset && typeof p.getAttribute === 'function')) {
      created = p.dataset.productCreated || '';
      updated = p.dataset.productUpdated || '';
      published = p.dataset.productPublished || '';
      idStr = p.dataset.productId || p.dataset.productHandle || '';
      if (!created && !updated) {
        const handle = p.dataset.productHandle || '';
        const catProducts = (window.RW_FILTER_INDEX && window.RW_FILTER_INDEX.products) ? window.RW_FILTER_INDEX.products : [];
        const catP = catProducts.find((x) => x.handle === handle);
        if (catP) {
          created = catP.createdAt || '';
          updated = catP.updatedAt || '';
          published = catP.publishedAt || '';
          idStr = catP.id || idStr;
        }
      }
    } else {
      created = p.createdAt || '';
      updated = p.updatedAt || '';
      published = p.publishedAt || '';
      idStr = String(p.id || p.variantId || '');
      if (!created && !updated && p.handle) {
        const catProducts = (window.RW_FILTER_INDEX && window.RW_FILTER_INDEX.products) ? window.RW_FILTER_INDEX.products : [];
        const catP = catProducts.find((x) => x.handle === p.handle);
        if (catP) {
          created = catP.createdAt || '';
          updated = catP.updatedAt || '';
          published = catP.publishedAt || '';
          idStr = catP.id || idStr;
        }
      }
    }

    const timeUpdated = updated ? new Date(updated).getTime() : 0;
    const timeCreated = created ? new Date(created).getTime() : 0;
    const timePublished = published ? new Date(published).getTime() : 0;

    const validTimes = [timeUpdated, timeCreated, timePublished].filter((t) => !isNaN(t) && t > 0);
    if (validTimes.length > 0) {
      return Math.max(...validTimes);
    }

    const idMatch = idStr.match(/\d{8,}/);
    if (idMatch) {
      return Number(idMatch[0]);
    }

    return 0;
  }

  const GLOBAL_EXCLUDED_HANDLES = new Set([
    'all', 'frontpage', 'catalog', 'video', 'click', 'live-data-girls', 'click-data-girl-s',
    'click-data-premium-1', 'click-auto-metal', 'auto-leather-silicon', 'live-data-automatic-metal',
    'live-data-leather-silicon', 'live-data-automatic-leather', 'live-data-sporty', 'box-photo',
    'og-box', 'click-data-auto-leather', 'click-data-lether', 'click-data-sporty', 'required-r3',
    'required-r5', 'custom', 'v9-collection', 'bistec', 'felix', 'boucheron', 'curren', 'happy-time',
    'iwc', 'monaco', 'signature', 'urban', 'automatic-metal', 'automatic-metal-edition'
  ]);

  function sanitizeCatalogCategories(catalog) {
    if (!catalog) return catalog;
    if (catalog._indexed) return catalog;

    const categories = catalog.categories || [];
    const products = catalog.products || [];

    const liveColMap = (window.RW_LIVE_COLLECTIONS && Array.isArray(window.RW_LIVE_COLLECTIONS) && window.RW_LIVE_COLLECTIONS.length > 0)
      ? new Set(window.RW_LIVE_COLLECTIONS.map(c => normalize(c.handle)))
      : null;

    const activeCounts = new Map();
    products.forEach((product) => {
      // Pre-compute normalized search fields for 0ms instantaneous lookups
      if (!product._normTitle) {
        product._normTitle = normalize(product.title || '');
        product._normVendor = normalize(product.vendor || '');
        product._normSearch = `${product._normTitle} ${product._normVendor} ${(product.categories || []).map(c => `${normalize(c.title || '')} ${normalize(c.handle || '')}`).join(' ')}`;
      }

      (product.categories || []).forEach((cat) => {
        if (!cat || !cat.handle) return;
        const h = normalize(cat.handle);
        if (GLOBAL_EXCLUDED_HANDLES.has(cat.handle) || GLOBAL_EXCLUDED_HANDLES.has(h)) return;
        if (liveColMap && !liveColMap.has(h)) return;
        activeCounts.set(h, (activeCounts.get(h) || 0) + 1);
      });
    });

    catalog.categories = categories.filter((cat) => {
      if (!cat || !cat.handle) return false;
      const h = normalize(cat.handle);
      if (GLOBAL_EXCLUDED_HANDLES.has(cat.handle) || GLOBAL_EXCLUDED_HANDLES.has(h)) return false;
      if (liveColMap && !liveColMap.has(h)) return false;
      const count = activeCounts.get(h) || 0;
      return count > 0;
    });

    catalog._indexed = true;
    return catalog;
  }

  function previewCatalog() {
    const raw = window.RW_PREVIEW_CATALOG || { categories: [], products: [] };
    return sanitizeCatalogCategories(raw);
  }

  function filterIndex() {
    const raw = window.RW_FILTER_INDEX || { categories: [], products: [] };
    return sanitizeCatalogCategories(raw);
  }

  function moneyInr(value) {
    const number = Number(value || 0);
    return number ? `₹${number.toLocaleString('en-IN')}` : '';
  }

  function moneyInrFromCents(value) {
    const number = Number(value || 0) / 100;
    return number ? `₹${number.toLocaleString('en-IN', { maximumFractionDigits: 0 })}` : '';
  }

  function previewProductsFor(query, limit) {
    const catalog = previewCatalog();
    const term = String(query || '').trim();
    const key = normalize(term);
    const upper = term.toLowerCase();
    if (!key || key === 'all' || key === 'catalog' || key === 'shop') {
      return catalog.products.slice(0, Number(limit || 24));
    }
    let matches = catalog.products.filter((product) => {
      return (
        product.categoryHandle === key ||
        normalize(product.category).includes(key) ||
        normalize(product.title).includes(key) ||
        product.title.toLowerCase().includes(upper) ||
        product.category.toLowerCase().includes(upper)
      );
    });
    if (!matches.length && key.includes('live-data-girls')) {
      matches = catalog.products.filter((product) => product.categoryHandle === 'girls-collection');
    }
    if (!matches.length && key.includes('sporty')) {
      matches = catalog.products.filter((product) => product.categoryHandle === 'sporty-models');
    }
    if (!matches.length && key.includes('automatic-leather')) {
      matches = catalog.products.filter((product) => product.categoryHandle === 'automatic-leather-silicon');
    }
    if (!matches.length && key.includes('automatic-metal')) {
      matches = catalog.products.filter((product) => product.categoryHandle === 'automatic-metal-edition');
    }
    return matches.slice(0, Number(limit || 12));
  }

  function decodeHandle(raw) {
    let str = String(raw || '').trim();
    if (str.includes('/products/')) {
      str = str.split('/products/')[1].split('?')[0].split('#')[0];
    }
    while (/%[0-9a-fA-F]{2}/.test(str)) {
      try {
        const decoded = decodeURIComponent(str);
        if (decoded === str) break;
        str = decoded;
      } catch (_) {
        break;
      }
    }
    return str;
  }

  function safeProductUrl(item) {
    if (!item) return '/';
    let raw = '';
    if (typeof item === 'object') {
      raw = item.handle || (item.url ? item.url.split('/products/')[1] : item.title || '');
    } else {
      raw = String(item);
    }
    const clean = decodeHandle(raw);
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/$/, '')}/products/${encodeURIComponent(clean)}`;
  }

  function internalProductUrl(product) {
    return safeProductUrl(product);
  }

  function hdImageUrl(url, width = '480') {
    if (!url) return '';
    try {
      const imageUrl = new URL(url, window.location.origin);
      if (imageUrl.hostname.includes('cdn.shopify.com') || imageUrl.pathname.includes('/cdn/shop/')) {
        imageUrl.searchParams.set('width', width);
      }
      return imageUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function updateWhatsAppLink(product) {
    const link = document.querySelector('[data-whatsapp-floating]');
    if (!link || !product) return;
    const number = link.dataset.whatsappNumber;
    if (!number) return;
    const baseMessage = link.dataset.whatsappProductMessage || 'Hi, I am interested in this product.';
    const productUrl = new URL(internalProductUrl(product), window.location.origin).toString();
    const message = `${baseMessage} ${product.title} - ${productUrl}`;
    const targetUrl = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    link.href = targetUrl;
    link.setAttribute('aria-label', `Open WhatsApp inquiry for ${product.title}`);

    const popupContent = document.querySelector('.whatsapp-popup__content');
    if (popupContent) {
      popupContent.href = targetUrl;
    }
  }

  function previewProductHtml(product) {
    const productUrl = internalProductUrl(product);
    const title = escapeHtml(product.title || '');
    const priceNum = Number(product.price || 0);
    const compareNum = Number(product.compareAtPrice || 0);
    const price = moneyInr(priceNum);
    const comparePrice = compareNum > priceNum ? moneyInr(compareNum) : '';
    const saved = compareNum > priceNum ? Math.round(((compareNum - priceNum) * 100) / compareNum) : 0;

    const rawImages = Array.isArray(product.images) && product.images.length
      ? product.images.map((img) => typeof img === 'string' ? img : (img?.src || img?.url)).filter(Boolean)
      : [product.image, product.hoverImage].filter(Boolean);

    const imagesList = Array.from(new Set(rawImages));

    const slidesHtml = imagesList.map((imgUrl, i) => `
      <a class="product-card__media-slide" href="${productUrl}" aria-label="View ${title} slide ${i + 1}">
        <img class="primary" src="${escapeHtml(hdImageUrl(imgUrl))}" alt="${title}" loading="lazy">
      </a>
    `).join('');

    return `
      <article
        class="product-card"
        data-product-card
        data-product-price="${escapeHtml(String(priceNum))}"
        data-product-compare="${escapeHtml(String(compareNum))}"
        data-product-discount="${saved}"
      >
        <div class="product-card__media" data-product-card-carousel>
          <div class="product-card__media-track" data-product-card-track aria-label="Product media for ${title}">
            ${slidesHtml}
          </div>
        </div>
        <div class="product-card__info">
          <h3 class="product-card__title" title="${title}"><a href="${productUrl}">${title}</a></h3>
          <div class="price-row">
            <span class="price">${price}</span>
            ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ''}
          </div>
          ${saved > 0 ? `<span class="product-card__discount">${saved}% OFF</span>` : '<div style="margin-bottom:8px;"></div>'}
          <a class="button" href="${productUrl}">Add to cart</a>
        </div>
      </article>
    `;
  }

  function renderPreviewProductDetail() {
    const target = document.querySelector('[data-preview-product-detail]');
    if (!target) return false;
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('preview_product');
    if (!handle) return false;
    const product = previewCatalog().products.find((item) => item.handle === handle);
    if (!product) return false;
    updateWhatsAppLink(product);
    document.querySelectorAll('[data-search-native-results], [data-preview-search-results], [data-preview-category-grid], [data-search-heading]').forEach((element) => {
      element.hidden = true;
    });
    target.hidden = false;
    target.innerHTML = `
      <div class="preview-detail">
        <div class="preview-detail__media">
          <img src="${hdImageUrl(product.image)}" alt="${product.title.replaceAll('"', '&quot;')}" loading="eager">
        </div>
        <div class="preview-detail__info">
          <a class="view-all" href="${window.Shopify.routes.root}search?q=${encodeURIComponent(product.category)}">Back to ${product.category}</a>
          <p class="badge">${product.category}</p>
          <h1 class="preview-detail__title">${product.title}</h1>
          <div class="preview-detail__price">${moneyInr(product.price)}</div>
          <p>This is an internal Shopify-hosted preview from the migrated Dukaan catalog audit. Import the product CSV to activate real Shopify cart and checkout for this item.</p>
          <div class="preview-detail__actions">
            <button class="button" type="button" disabled>Add to cart after import</button>
            <a class="button button-secondary" href="${window.Shopify.routes.root}search?q=${encodeURIComponent(product.category)}">More in this category</a>
          </div>
        </div>
      </div>
    `;
    return true;
  }

  function renderPreviewGrids() {
    document.querySelectorAll('[data-preview-grid]').forEach((grid) => {
      const products = previewProductsFor(grid.dataset.previewCategory, grid.dataset.previewLimit || 8);
      const empty = grid.parentElement?.querySelector('[data-preview-empty]');
      if (!products.length) {
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      grid.innerHTML = products.map(previewProductHtml).join('');
      initProductCardCarousels(grid);
    });
  }

  function renderPreviewCategoryGrid() {
    const catalog = previewCatalog();
    const grids = document.querySelectorAll('[data-preview-category-grid]');
    grids.forEach((grid) => {
      grid.innerHTML = catalog.categories.slice(0, 24).map((category) => `
        <a class="category-card" href="${window.Shopify.routes.root}search?q=${encodeURIComponent(category.title)}">
          <span class="category-card__media"><img src="${category.image}" alt="${category.title}" loading="lazy"></span>
          <span>${category.title}</span>
        </a>
      `).join('');
    });
  }

  function renderPreviewSearchCategories() {
    const catalog = previewCatalog();
    document.querySelectorAll('[data-preview-search-categories]').forEach((target) => {
      target.innerHTML = catalog.categories.slice(0, 10).map((category) => `
        <a class="preview-chip" href="${window.Shopify.routes.root}search?q=${encodeURIComponent(category.title)}">${category.title}</a>
      `).join('');
    });
  }

  function renderPreviewSearchResults() {
    if (renderPreviewProductDetail()) return;
    document.querySelectorAll('[data-preview-search-results]').forEach((grid) => {
      const products = previewProductsFor(grid.dataset.query, 24);
      grid.innerHTML = products.length ? products.map(previewProductHtml).join('') : '<div class="empty-state">No catalog preview results found.</div>';
      if (products.length) initProductCardCarousels(grid);
    });
  }

  function setCartCount(count) {
    document.querySelectorAll(selectors.cartCount).forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  async function refreshCartDrawer() {
    const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('#CartDrawer');
    const current = document.querySelector('#CartDrawer');
    if (next && current) current.innerHTML = next.innerHTML;
    syncStoredDiscountFromCart();
    initCartRecommendationScroll();
  }

    const MAX_ORDER_QUANTITY = 5;

  window.RW_showLimitWarning = function (msg) {
    const warning = msg || `Order limit reached: Maximum ${MAX_ORDER_QUANTITY} items allowed per order for fraud prevention & Paytm compliance. For bulk orders (>5 items), please contact us on WhatsApp (+91 73875 10084) for manual confirmation.`;
    toast(warning, true);
  };

    async function addToCart(form, button) {
    const formData = new FormData(form);
    const requestedQty = Number(formData.get('quantity') || 1);

    if (requestedQty > MAX_ORDER_QUANTITY) {
      window.RW_showLimitWarning();
      return;
    }

    button?.classList.add('is-loading');
    button?.setAttribute('disabled', 'disabled');
    try {
      const currentCart = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json()).catch(() => ({ item_count: 0 }));
      if ((Number(currentCart.item_count || 0) + requestedQty) > MAX_ORDER_QUANTITY) {
        toast(`Order limit reached (${currentCart.item_count} items currently in cart). Maximum ${MAX_ORDER_QUANTITY} items allowed per order for fraud prevention & Paytm compliance. Please contact us on WhatsApp for manual confirmation on bulk orders.`, true);
        button?.classList.remove('is-loading');
        button?.removeAttribute('disabled');
        return;
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || error.message || 'Unable to add item.');
      }
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());
      setCartCount(cart.item_count);
      await refreshCartDrawer();
      cartToast(await response.json().catch(() => null) || {});
      const submit = form.querySelector('[type="submit"]');
      if (submit && form.matches('[data-product-form]')) {
        submit.textContent = 'Go to cart';
        submit.dataset.goToCart = 'true';
      }
    } catch (error) {
      toast(error.message || 'Cart update failed', true);
    } finally {
      button?.classList.remove('is-loading');
      button?.removeAttribute('disabled');
    }
  }

    async function updateCart(line, quantity) {
    try {
      const targetQty = Number(quantity);
      if (targetQty > 0) {
        const currentCart = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json()).catch(() => ({ item_count: 0, items: [] }));
        const targetItem = currentCart.items ? currentCart.items[Number(line) - 1] : null;
        const currentItemQty = targetItem ? targetItem.quantity : 0;
        const diff = targetQty - currentItemQty;
        if (diff > 0 && (Number(currentCart.item_count || 0) + diff) > MAX_ORDER_QUANTITY) {
          toast(`Cannot add more than ${MAX_ORDER_QUANTITY} total items to an order for fraud prevention & payment compliance. For bulk orders, please contact us on WhatsApp.`, true);
          await refreshCartDrawer();
          return;
        }
      }

      window.localStorage.removeItem('rwDiscountCode');
      window.localStorage.setItem('rwDiscountInvalidated', 'true');
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      setCartCount(cart.item_count);
      if (document.querySelector('[data-cart-page]') && !activeDrawer) {
        window.location.reload();
        return;
      }
      await refreshCartDrawer();
    } catch (error) {
      toast(error.message, true);
    }
  }

  function openCouponModal() {
    const modal = document.querySelector('[data-coupon-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('is-locked');
    window.setTimeout(() => {
      const input = modal.querySelector('input[name="discount"]');
      if (!input) return;
      input.value = '';
      input.focus();
    }, 40);
  }

  function closeCouponModal() {
    const modal = document.querySelector('[data-coupon-modal]');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (!activeDrawer && !activeLightbox) document.body.classList.remove('is-locked');
  }

  async function applyDiscountCode(form, button) {
    const input = form.querySelector('input[name="discount"]');
    const feedback = form.closest('[data-coupon-modal]')?.querySelector('[data-coupon-feedback]')
      || document.querySelector('[data-coupon-feedback]');
    const code = String(input?.value || '').trim().toUpperCase();
    if (!code) return;

    // Reset feedback state
    if (feedback) {
      feedback.hidden = true;
      feedback.className = 'coupon-feedback';
      feedback.textContent = '';
    }

    // Show loading state
    button?.classList.add('is-loading');
    button?.setAttribute('disabled', 'disabled');
    input?.setAttribute('disabled', 'disabled');

    try {
      // Step 1: Hit Shopify's discount endpoint via fetch (no browser redirect)
      const root = window.Shopify?.routes?.root || '/';
      await fetch(`${root}discount/${encodeURIComponent(code)}`, {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow',
        headers: { 'Accept': 'text/html' }
      });

      // Step 2: Read cart state to see if discount was accepted
      const cartRes = await fetch(`${root}cart.js`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      const cart = await cartRes.json();

      // Step 3: Check discount_applications for our code
      const applications = cart.cart_level_discount_applications || [];
      const matched = applications.find(
        (d) => d.title && d.title.toUpperCase() === code
      );

      if (matched) {
        // Valid coupon - persist and show success
        window.localStorage.setItem('rwDiscountCode', code);
        window.localStorage.removeItem('rwPendingDiscountCode');
        window.localStorage.removeItem('rwDiscountInvalidated');

        let savingText = '';
        if (matched.type === 'percentage' && matched.value) {
          savingText = ` You save ${parseFloat(matched.value)}%!`;
        } else if (matched.type === 'fixed_amount' && matched.value) {
          savingText = ` You save ₹${parseFloat(matched.value)}!`;
        }

        if (feedback) {
          feedback.className = 'coupon-feedback coupon-feedback--success';
          feedback.innerHTML = `<span class="coupon-feedback__icon" aria-hidden="true">✓</span> Coupon <strong>${code}</strong> applied!${savingText}`;
          feedback.hidden = false;
        }

        // Refresh cart drawer to show updated totals
        try { await refreshCartDrawer(); } catch (_) {}

        // Auto-close modal after success
        window.setTimeout(() => closeCouponModal(), 1600);

      } else {
        // Invalid coupon - stay in modal, show error, re-enable form
        window.localStorage.removeItem('rwDiscountCode');
        window.localStorage.removeItem('rwPendingDiscountCode');
        window.localStorage.setItem('rwDiscountInvalidated', 'true');

        if (feedback) {
          feedback.className = 'coupon-feedback coupon-feedback--error';
          feedback.innerHTML = `<span class="coupon-feedback__icon" aria-hidden="true">✕</span> <strong>${code}</strong> is not a valid coupon code.`;
          feedback.hidden = false;
        }

        button?.classList.remove('is-loading');
        button?.removeAttribute('disabled');
        input?.removeAttribute('disabled');
        input?.select();
      }

    } catch (err) {
      // Network or unexpected error
      if (feedback) {
        feedback.className = 'coupon-feedback coupon-feedback--error';
        feedback.innerHTML = `<span class="coupon-feedback__icon" aria-hidden="true">✕</span> Something went wrong. Please try again.`;
        feedback.hidden = false;
      }
      button?.classList.remove('is-loading');
      button?.removeAttribute('disabled');
      input?.removeAttribute('disabled');
    }
  }

  function persistCheckoutDiscount(form) {
    const submit = form.querySelector('[name="checkout"]');
    if (!submit) return;
    if (window.localStorage.getItem('rwDiscountInvalidated') === 'true') {
      form.querySelectorAll('input[name="discount"]').forEach((input) => input.remove());
      return;
    }
    const code = document.querySelector('[data-active-discount-code]')?.value || window.localStorage.getItem('rwDiscountCode');
    if (!code) return;
    let input = form.querySelector('input[name="discount"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'discount';
      form.appendChild(input);
    }
    input.value = code;
  }

      async function goDirectlyToCheckout(form) {
    try {
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json()).catch(() => ({ item_count: 0 }));
      if (Number(cart.item_count || 0) > MAX_ORDER_QUANTITY) {
        toast(`Order limit exceeded (${cart.item_count} items). Maximum ${MAX_ORDER_QUANTITY} items allowed per order for fraud prevention & Paytm compliance. For bulk orders (>5 items), please contact us on WhatsApp for manual confirmation.`, true);
        const submit = form.querySelector('[name="checkout"]');
        submit?.classList.remove('is-loading');
        submit?.removeAttribute('disabled');
        return;
      }
    } catch (_) {}
    persistCheckoutDiscount(form);
    const checkoutUrl = new URL(`${window.location.origin}${window.Shopify.routes.root}checkout`);
    const discount = form.querySelector('input[name="discount"]')?.value;
    if (discount) checkoutUrl.searchParams.set('discount', discount);
    window.location.href = checkoutUrl.toString();
  }

  function syncStoredDiscountFromCart() {
    const activeCode = document.querySelector('[data-active-discount-code]')?.value;
    if (activeCode) {
      window.localStorage.setItem('rwDiscountCode', activeCode);
      window.localStorage.removeItem('rwPendingDiscountCode');
      window.localStorage.removeItem('rwDiscountInvalidated');
      return;
    }
    window.localStorage.removeItem('rwDiscountCode');
    window.localStorage.removeItem('rwPendingDiscountCode');
  }

  function initCartRecommendationScroll() {
    document.querySelectorAll('.cart-recommendations__scroller--cards').forEach((scroller) => {
      if (scroller.dataset.dragScrollReady === 'true') return;
      scroller.dataset.dragScrollReady = 'true';
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let dragging = false;
      let moved = false;
      let horizontalDrag = false;

      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        moved = false;
        horizontalDrag = false;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = scroller.scrollLeft;
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (!horizontalDrag) {
          if (absY > absX && absY > 6) {
            dragging = false;
            return;
          }
          if (absX < 6 || absX <= absY) return;
          horizontalDrag = true;
        }
        moved = true;
        scroller.scrollLeft = startScrollLeft - deltaX;
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach((type) => {
        scroller.addEventListener(type, () => {
          dragging = false;
          horizontalDrag = false;
        });
      });

      scroller.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    });
  }

  function initProductOptions(scope) {
    const forms = scope.querySelectorAll('[data-product-form]');
    forms.forEach((form) => {
      const variantsScript = form.querySelector('[data-variants-json]');
      if (!variantsScript) return;
      const variants = JSON.parse(variantsScript.textContent);
      const idInput = form.querySelector('input[name="id"]');
      const price = scope.querySelector('[data-product-price]');
      const compare = scope.querySelector('[data-product-compare]');
      const discount = scope.querySelector('[data-product-discount]');
      const submit = form.querySelector('[type="submit"]');
      const update = () => {
        const selected = Array.from(form.querySelectorAll('[data-option-position]')).map((group) => {
          const checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        idInput.value = variant.id;
        if (price) price.textContent = moneyInrFromCents(variant.price);
        if (compare) {
          compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? moneyInrFromCents(variant.compare_at_price) : '';
          compare.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
        }
        if (discount) {
          const show = variant.compare_at_price && variant.compare_at_price > variant.price;
          discount.hidden = !show;
          if (show) discount.textContent = `(${Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)}% OFF)`;
        }
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldOutText;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };
      form.addEventListener('change', update);
      update();
    });
  }

  function deliveryEstimateForPincode(pincode) {
    if (!/^[1-9][0-9]{5}$/.test(pincode)) {
      return { error: 'Enter a valid 6-digit Indian PIN code.' };
    }
    const zone = Number(pincode.slice(0, 2));
    let estimate = '4-7 business days';
    if (zone === 44) {
      estimate = '1-2 business days';
    } else if ([40, 41, 42, 43].includes(zone)) {
      estimate = '2-4 business days';
    } else if ((zone >= 11 && zone <= 39) || (zone >= 45 && zone <= 85)) {
      estimate = '3-6 business days';
    }
    return {
      message: `Delivery to ${pincode} is expected in ${estimate}. Free shipping will be applied at checkout.`
    };
  }

  function initDeliveryCheckers(scope) {
    scope.querySelectorAll('[data-delivery-form]').forEach((form) => {
      const input = form.querySelector('[data-delivery-pincode]');
      const result = form.closest('[data-delivery-checker]')?.querySelector('[data-delivery-result]');
      if (!input || !result) return;
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const pincode = input.value.replace(/\D/g, '').slice(0, 6);
        input.value = pincode;
        const estimate = deliveryEstimateForPincode(pincode);
        result.textContent = estimate.error || estimate.message;
        result.classList.toggle('is-error', Boolean(estimate.error));
      });
    });
  }

  function catalogSearchResults(query, limit) {
    return [];
  }

    function initDynamicCategoryFilters() {
    const lists = Array.from(document.querySelectorAll('[data-dynamic-category-list]'));
    const grid = document.querySelector('[data-collection-grid]');
    if (!lists.length || !grid) return;

    const selected = new Set();
    const urlParams = new URLSearchParams(window.location.search);
    const selectedPriceRanges = new Set();
    let categorySearchTerm = '';
    let currentRenderLimit = 30;
    let lastFilteredProducts = [];

    function parsePriceRangeKey(key) {
      const parts = String(key || '').split('-').map(Number);
      if (parts.length >= 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        return { min: parts[0], max: parts[1], key: String(key) };
      }
      return null;
    }

    // System / dummy / deleted handles to exclude
    const excludedHandles = new Set([
      'all', 'all-products', 'frontpage', 'catalog', 'video', 'click',
      'box-photo', 'og-box', 'custom', 'hd-video-all', 'live-data-girls',
      'click-data-girl-s', 'click-data-premium-1', 'click-auto-metal',
      'live-data-automatic-metal', 'live-data-leather-silicon', 'live-data-automatic-leather',
      'live-data-sporty', 'click-data-auto-leather', 'click-data-lether', 'click-data-sporty',
      'required-r3', 'required-r5', 'r-watches-ngp', 'r-watches', 'rwatches', 'ap', 'rm', 'ck', 'ax', 'lv'
    ]);

    const NON_BRAND_HANDLES = new Set([
      'all', 'all-products', 'frontpage', 'catalog', 'video', 'click',
      'box-photo', 'og-box', 'custom', 'hd-video-all', 'live-data-girls',
      'click-data-girl-s', 'click-data-premium-1', 'click-auto-metal',
      'live-data-automatic-metal', 'live-data-leather-silicon', 'live-data-automatic-leather',
      'live-data-sporty', 'click-data-auto-leather', 'click-data-lether', 'click-data-sporty',
      'required-r3', 'required-r5', 'r-watches-ngp', 'r-watches', 'rwatches', 'ap', 'rm', 'ck', 'ax', 'lv',
      'leather-silicon', 'automatic-metal', 'automatic-metal-edition',
      'auto-leather-silicon', 'girls-collection', 'girls', 'girl-s',
      'premium', 'sporty', 'sporty-models', 'sporty-33', 'rings',
      'master', 'signature', 'smartwatches', 'spinner'
    ]);

    let cachedDynamicBrandLookup = null;
    function getDynamicBrandLookup() {
      if (cachedDynamicBrandLookup !== null) return cachedDynamicBrandLookup;
      const brandItems = [];
      const seen = new Set();
      if (Array.isArray(window.RW_LIVE_COLLECTIONS)) {
        for (let i = 0; i < window.RW_LIVE_COLLECTIONS.length; i++) {
          const c = window.RW_LIVE_COLLECTIONS[i];
          if (!c || !c.handle) continue;
          const hNorm = normalize(c.handle);
          if (NON_BRAND_HANDLES.has(hNorm) || NON_BRAND_HANDLES.has(c.handle)) continue;
          const name = getCanonicalBrandName(c.title || c.handle);
          const nameNorm = normalize(name);
          if (seen.has(nameNorm)) continue;
          seen.add(nameNorm);
          brandItems.push({
            name: name,
            handle: c.handle,
            norm: nameNorm,
            low: name.toLowerCase()
          });
        }
      }
      brandItems.sort(function(a, b) { return b.name.length - a.name.length; });
      cachedDynamicBrandLookup = brandItems;
      return cachedDynamicBrandLookup;
    }

    function isSameBrandOrCollection(catHandle, catTitle, curHandle, curTitle) {
      if (!curHandle) return false;
      const hA = normalize(catHandle);
      const hB = normalize(curHandle);
      if (hA === hB) return true;
      if (getCanonicalHandle(hA) === getCanonicalHandle(hB)) return true;

      const tA = normalize(catTitle);
      const tB = normalize(curTitle);
      if (tA && tB && tA === tB) return true;
      if (tA && tA === hB) return true;
      if (tB && tB === hA) return true;

      const stemA = hA.replace(/-\d+$/, '');
      const stemB = hB.replace(/-\d+$/, '');
      if (stemA && stemB && stemA === stemB) return true;
      if (tA && stemB && tA === stemB) return true;
      if (tB && stemA && tB === stemA) return true;

      return false;
    }

    function resolveProductBrand(p) {
      if (!p) return { brand: '', brandHandle: '', brandNorm: '', brandCanon: '' };
      if (p._brand && p._brandHandle) {
        return {
          brand: p._brand,
          brandHandle: p._brandHandle,
          brandNorm: p._brandNorm || normalize(p._brand),
          brandCanon: p._brandCanon || canonicalSearchTerm(p._brand)
        };
      }

      const lookup = getDynamicBrandLookup();
      const colHandles = Array.isArray(p.collectionHandles) && p.collectionHandles.length > 0
        ? p.collectionHandles
        : (p.categories || []).map(function(c) { return normalize(c.handle); }).filter(Boolean);

      // 1. Authoritative Brand Collection Membership
      for (let i = 0; i < colHandles.length; i++) {
        const hNorm = colHandles[i];
        if (NON_BRAND_HANDLES.has(hNorm)) continue;
        for (let j = 0; j < lookup.length; j++) {
          if (hNorm === lookup[j].norm || hNorm === normalize(lookup[j].handle)) {
            const bName = lookup[j].name;
            const bHandle = lookup[j].handle;
            return {
              brand: bName,
              brandHandle: bHandle,
              brandNorm: lookup[j].norm,
              brandCanon: canonicalSearchTerm(bName)
            };
          }
        }
      }

      // 2. Existing reliable brand metadata on product
      if (p.brand && typeof p.brand === 'string') {
        const bNorm = normalize(p.brand);
        for (let j = 0; j < lookup.length; j++) {
          if (bNorm === lookup[j].norm) {
            return {
              brand: lookup[j].name,
              brandHandle: lookup[j].handle,
              brandNorm: lookup[j].norm,
              brandCanon: canonicalSearchTerm(lookup[j].name)
            };
          }
        }
      }

      // 3. Genuine brand-specific vendor
      const vendor = (p.vendor || '').trim();
      const vNorm = normalize(vendor);
      if (vendor && !vNorm.includes('r-watches') && !vNorm.includes('rwatches') && !NON_BRAND_HANDLES.has(vNorm)) {
        for (let j = 0; j < lookup.length; j++) {
          if (vNorm === lookup[j].norm) {
            return {
              brand: lookup[j].name,
              brandHandle: lookup[j].handle,
              brandNorm: lookup[j].norm,
              brandCanon: canonicalSearchTerm(lookup[j].name)
            };
          }
        }
      }

      // 4. Title inference fallback (sorted longest to shortest)
      const titleLower = String(p.title || '').toLowerCase();
      for (let i = 0; i < lookup.length; i++) {
        if (titleLower.includes(lookup[i].low)) {
          return {
            brand: lookup[i].name,
            brandHandle: lookup[i].handle,
            brandNorm: lookup[i].norm,
            brandCanon: canonicalSearchTerm(lookup[i].name)
          };
        }
      }

      // Final fallback to vendor if not generic store name
      if (vendor && !vNorm.includes('r-watches') && !vNorm.includes('rwatches') && !NON_BRAND_HANDLES.has(vNorm)) {
        return {
          brand: vendor,
          brandHandle: vNorm,
          brandNorm: vNorm,
          brandCanon: canonicalSearchTerm(vendor)
        };
      }

      return { brand: '', brandHandle: '', brandNorm: '', brandCanon: '' };
    }

    function detectProductBrand(product) {
      if (!product) return '';
      if (product._brand) return product._brand;
      return resolveProductBrand(product).brand;
    }

    function indexProduct(p, idx) {
      if (p._indexed) return p;

      // 1. Resolve canonical brand
      const brandInfo = resolveProductBrand(p);
      const brand = brandInfo.brand;
      const brandHandle = brandInfo.brandHandle;
      const brandNorm = brandInfo.brandNorm;
      const brandCanon = brandInfo.brandCanon;

      // 2. Build canonical collection set (ACTUAL collection membership ONLY)
      const collectionSet = new Set();
      const colHandles = Array.isArray(p.collectionHandles) && p.collectionHandles.length > 0
        ? p.collectionHandles
        : (p.categories || []).map(function(c) { return normalize(c.handle); }).filter(Boolean);

      for (let i = 0; i < colHandles.length; i++) {
        const hNorm = colHandles[i];
        collectionSet.add(hNorm);
        if (hNorm === 'bvlgari') collectionSet.add('bulgari');
        if (hNorm === 'bulgari') collectionSet.add('bvlgari');
        if (hNorm === 'sporty' || hNorm === 'sporty-33' || hNorm === 'sporty-models') {
          collectionSet.add('sporty');
          collectionSet.add('sporty-33');
          collectionSet.add('sporty-models');
        }
        if (hNorm === 'automatic-metal-edition' || hNorm === 'automatic-metal') {
          collectionSet.add('automatic-metal');
          collectionSet.add('automatic-metal-edition');
        }
        if (hNorm === 'auto-leather-silicon' || hNorm === 'automatic-leather-silicon') {
          collectionSet.add('auto-leather-silicon');
          collectionSet.add('automatic-leather-silicon');
        }
        if (hNorm === 'girls-collection' || hNorm === 'girls' || hNorm === 'girl-s') {
          collectionSet.add('girls-collection');
          collectionSet.add('girls');
          collectionSet.add('girl-s');
        }
      }

      // Also map collection titles for canonical resolution
      const cats = p.categories || [];
      for (let i = 0; i < cats.length; i++) {
        const c = cats[i];
        if (c.title) {
          const tNorm = normalize(c.title);
          collectionSet.add(tNorm);
          if (tNorm === 'bvlgari') collectionSet.add('bulgari');
          if (tNorm === 'bulgari') collectionSet.add('bvlgari');
        }
      }

      // 3. Build unified _catSet: contains collectionSet + canonical brand handles
      const catSet = new Set(collectionSet);

      if (brandHandle) {
        catSet.add(brandHandle);
        catSet.add(normalize(brandHandle));
      }
      if (brandNorm) {
        catSet.add(brandNorm);
        if (brandNorm === 'bvlgari') catSet.add('bulgari');
        if (brandNorm === 'bulgari') catSet.add('bvlgari');
      }

      const timeU = p.updatedAt ? new Date(p.updatedAt).getTime() : 0;
      const timeC = p.createdAt ? new Date(p.createdAt).getTime() : 0;
      const timeP = p.publishedAt ? new Date(p.publishedAt).getTime() : 0;
      const validTimes = [timeU, timeC, timeP].filter(t => !isNaN(t) && t > 0);
      let timestamp = validTimes.length ? Math.max(...validTimes) : 0;
      if (!timestamp) {
        const idStr = String(p.id || p.variantId || p.handle || '');
        const idMatch = idStr.match(/\d{8,}/);
        timestamp = idMatch ? Number(idMatch[0]) : idx;
      }

      const pPrice = Number(p.price || 0);
      const pCompare = Number(p.compareAtPrice || 0);
      const pDiscount = pCompare > pPrice ? Math.round(((pCompare - pPrice) * 100) / pCompare) : 0;

      p._brand = brand;
      p._brandHandle = brandHandle;
      p._brandNorm = brandNorm;
      p._brandCanon = brandCanon || canonicalSearchTerm(brand || p.vendor || '');
      p._titleCanon = canonicalSearchTerm(p.title || '');
      p._searchCanon = canonicalSearchTerm((p.title || '') + ' ' + (p.vendor || '') + ' ' + (brand || '') + ' ' + cats.map(c => (c.title || '') + ' ' + (c.handle || '')).join(' '));
      p._searchStr = normalize(p.title || '') + ' ' + normalize(p.vendor || '') + ' ' + brandNorm + ' ' + cats.map(c => normalize(c.title || '') + ' ' + normalize(c.handle || '')).join(' ');
      p._collectionSet = collectionSet;
      p._catSet = catSet;
      p._price = pPrice;
      p._comparePrice = pCompare;
      p._discount = pDiscount;
      p._timestamp = timestamp;
      p._indexed = true;

      return p;
    }

    function productMatchesCategoryOrBrand(product, target) {
      if (!product || !target) return false;
      if (!product._indexed) indexProduct(product);
      const tNorm = normalize(target);
      return product._catSet.has(target) || product._catSet.has(tNorm);
    }

    // Parse initial URL filters
    const syncStateFromUrl = () => {
      const currentParams = new URLSearchParams(window.location.search);
      selected.clear();
      String(currentParams.get('rw_category') || '')
        .split(',')
        .map(function(v) { return normalize(v); })
        .filter(Boolean)
        .forEach(function(v) { selected.add(v); });

      currentParams.getAll('filter.p.vendor').forEach(function(v) {
        const norm = normalize(v);
        if (norm) selected.add(norm);
      });

      selectedPriceRanges.clear();
      const rawPriceRanges = currentParams.get('rw_price_ranges');
      if (rawPriceRanges) {
        rawPriceRanges.split(',').map(function(s) { return s.trim(); }).filter(Boolean).forEach(function(k) {
          if (parsePriceRangeKey(k)) selectedPriceRanges.add(k);
        });
      } else if (currentParams.has('filter.v.price.gte') || currentParams.has('filter.v.price.lte') || currentParams.has('rw_price_min') || currentParams.has('rw_price_max')) {
        const min = Number(currentParams.get('filter.v.price.gte') || currentParams.get('rw_price_min') || 0);
        const max = Number(currentParams.get('filter.v.price.lte') || currentParams.get('rw_price_max') || Infinity);
        if (min > 0 || (max > 0 && max < Infinity)) {
          selectedPriceRanges.add(`${min}-${max}`);
        }
      }

      const sortParam = currentParams.get('sort_by');
      if (sortParam) {
        userExplicitSort = sortParam;
      }
    };
    syncStateFromUrl();

    const getAllCatalogProducts = () => {
      const domProducts = parseInitialDomCards();
      const index = filterIndex();
      const rawProducts = (index && index.products && index.products.length)
        ? index.products
        : ((previewCatalog() && previewCatalog().products) || []);

      if (!rawProducts.length) {
        return domProducts;
      }

      // Live DOM products are authoritative and take precedence over any static catalog
      const merged = [];
      const seen = new Set();

      for (let i = 0; i < domProducts.length; i++) {
        const p = domProducts[i];
        if (!p._indexed) indexProduct(p, i);
        merged.push(p);
        if (p.handle) seen.add(p.handle);
      }

      for (let i = 0; i < rawProducts.length; i++) {
        const p = rawProducts[i];
        if (p.handle && seen.has(p.handle)) continue;
        if (!p._indexed) indexProduct(p, merged.length);
        merged.push(p);
        if (p.handle) seen.add(p.handle);
      }

      return merged;
    };

    function parseProductCard(card, idx) {
      const titleEl = card.querySelector('.product-card__title a') || card.querySelector('.product-card__title');
      const title = titleEl ? titleEl.textContent.trim() : '';
      const linkEl = card.querySelector('a[href*="/products/"]');
      const href = linkEl ? linkEl.getAttribute('href') || '' : '';
      const rawHandle = card.dataset.productHandle || (href.includes('/products/') ? href.split('/products/')[1].split('?')[0] : '');
      const handle = decodeHandle(rawHandle);
      const price = Number(card.dataset.productPrice || 0);
      const compareAtPrice = Number(card.dataset.productCompare || 0);
      const catLabels = (card.dataset.productCategoryLabels || '').split('||').map(function(s) { return s.trim(); }).filter(Boolean);
      const catValues = (card.dataset.productCollections || card.dataset.productCategoryValues || '').split('||').map(function(s) { return s.trim(); }).filter(Boolean);
      const categories = [];
      const collectionHandles = [];
      catValues.forEach(function(h, i) {
        if (h) {
          categories.push({ handle: h, title: catLabels[i] || h });
          collectionHandles.push(normalize(h));
        }
      });
      const productType = (card.dataset.productType || '').trim();
      const vendor = (card.dataset.productVendor || card.dataset.productCategory || '').trim();
      const images = Array.from(card.querySelectorAll('.product-card__media-slide img')).map(function(img) { return img.src; }).filter(Boolean);
      const variantId = card.querySelector('input[name="id"]')?.value || '';
      const createdAt = card.dataset.productCreated || '';
      const updatedAt = card.dataset.productUpdated || '';
      const publishedAt = card.dataset.productPublished || '';
      const productId = card.dataset.productId || '';
      const pObj = {
        id: productId || variantId || handle || String(idx),
        variantId: variantId,
        handle: handle,
        title: title,
        price: price,
        compareAtPrice: compareAtPrice,
        categories: categories,
        collectionHandles: collectionHandles,
        productType: productType,
        images: images,
        image: images[0] || '',
        hoverImage: images[1] || images[0] || '',
        vendor: vendor,
        createdAt: createdAt,
        updatedAt: updatedAt,
        publishedAt: publishedAt,
        available: !card.querySelector('button[disabled]')
      };
      return indexProduct(pObj, idx);
    }

    // Cache initial DOM cards on first load BEFORE any filtering mutates the grid
    let cachedInitialDomProducts = null;
    const parseInitialDomCards = () => {
      if (cachedInitialDomProducts !== null) return cachedInitialDomProducts;
      const domCards = Array.from(grid.querySelectorAll('[data-product-card]'));
      if (!domCards.length) {
        return [];
      }
      cachedInitialDomProducts = domCards.map(function(card, idx) {
        return parseProductCard(card, idx);
      });
      return cachedInitialDomProducts;
    };

    const isCollectionPage = () => {
      const currentPath = window.location.pathname;
      return currentPath.includes('/collections/') && !currentPath.endsWith('/collections');
    };

    const currentCollectionHandle = () => {
      if (!window.location.pathname.includes('/collections/') || window.location.pathname.endsWith('/collections')) return null;
      const rawHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0]?.split('?')[0];
      return rawHandle ? decodeURIComponent(rawHandle) : null;
    };

    let initialGridNextUrl = grid.dataset.nextUrl || '';
    const hasMoreCollectionPages = () => {
      if (!isCollectionPage()) return false;
      return Boolean(initialGridNextUrl);
    };

    const fullCollectionScopeCache = new Map();
    let completeScopePromise = null;

    const fetchCompleteCollectionScope = async (colHandle) => {
      if (!colHandle) return parseInitialDomCards();
      const cached = fullCollectionScopeCache.get(colHandle);
      if (cached && cached.length) return cached;

      if (completeScopePromise) return completeScopePromise;

      completeScopePromise = (async () => {
        try {
          const domProducts = parseInitialDomCards();
          const merged = [...domProducts];
          const seenIds = new Set(domProducts.map(p => p.id || p.handle));

          let nextUrl = initialGridNextUrl;
          let pageGuard = 0;

          while (nextUrl && pageGuard < 20) {
            pageGuard++;
            const res = await fetch(nextUrl, {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!res.ok) break;
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const nextGrid = doc.querySelector('#CollectionProductsGrid, [data-collection-grid]');
            if (!nextGrid) break;

            const cards = Array.from(nextGrid.querySelectorAll('[data-product-card]'));
            cards.forEach(card => {
              const p = parseProductCard(card, merged.length);
              const key = p.id || p.handle;
              if (key && !seenIds.has(key)) {
                seenIds.add(key);
                merged.push(p);
              }
            });

            const nextMatch = nextGrid.dataset.nextUrl || doc.querySelector('[data-infinite-grid]')?.dataset?.nextUrl || '';
            nextUrl = nextMatch && nextMatch !== nextUrl ? nextMatch : null;
          }

          fullCollectionScopeCache.set(colHandle, merged);
          return merged;
        } catch (err) {
          console.warn('[RW Scope] Complete collection scope load error:', err);
          return parseInitialDomCards();
        } finally {
          completeScopePromise = null;
        }
      })();

      return completeScopePromise;
    };

    // Pre-parse immediately upon initialization
    parseInitialDomCards();

    // Cache contextual base products for current page context
    let cachedContextualProducts = null;
    const getContextualProducts = () => {
      if (cachedContextualProducts !== null) return cachedContextualProducts;

      const onCollectionPage = isCollectionPage();
      const collectionHandle = currentCollectionHandle();

      const domProducts = parseInitialDomCards();
      const allCatalog = getAllCatalogProducts();

      let baseProducts = [];

      if (onCollectionPage && collectionHandle) {
        if (collectionHandle === 'all' || collectionHandle === 'all-products' || collectionHandle === 'frontpage' || collectionHandle === 'catalog') {
          baseProducts = domProducts.length ? domProducts : allCatalog;
        } else {
          // If full complete collection scope has been loaded for multi-page collection, use it
          const fullScope = fullCollectionScopeCache.get(collectionHandle);
          if (fullScope && fullScope.length > 0) {
            baseProducts = fullScope;
          } else if (domProducts.length > 0) {
            baseProducts = domProducts;
          } else {
            const cNorm = normalize(collectionHandle);
            const matchedInCatalog = allCatalog.filter(function(product) {
              return product._catSet && (product._catSet.has(collectionHandle) || product._catSet.has(cNorm));
            });
            baseProducts = matchedInCatalog.length ? matchedInCatalog : domProducts;
          }
        }
      } else if (domProducts.length > 0) {
        baseProducts = domProducts;
      } else {
        baseProducts = allCatalog;
      }

      if (window.location.pathname.includes('/search')) {
        const rawQuery = String(urlParams.get('q') || '').trim();
        const cleanQuery = rawQuery.replace(/["*]/g, '').replace(/\bAND\b/gi, ' ').trim();
        const qCanon = canonicalSearchTerm(cleanQuery);
        const qTokens = canonicalTokens(cleanQuery);

        if (!qCanon || !qTokens.length) {
          cachedContextualProducts = baseProducts;
          return cachedContextualProducts;
        }

        const resolved = resolveSearchBrand(cleanQuery, window.RW_LIVE_COLLECTIONS);
        const resolvedCanon = resolved ? canonicalSearchTerm(resolved.brand || resolved.handle) : '';

        cachedContextualProducts = baseProducts.filter(function(product) {
          const pCanon = product._searchCanon || canonicalSearchTerm((product.title || '') + ' ' + (product.vendor || '') + ' ' + (product._brand || ''));

          // 1. If resolved brand (e.g. GSHOCK -> G-Shock, SEV -> Sevenfriday, Tommy -> Tommy Hilfiger)
          if (resolvedCanon) {
            const pBrandCanon = product._brandCanon || canonicalSearchTerm(product._brand || product.vendor || '');
            if (pBrandCanon === resolvedCanon || pCanon.includes(resolvedCanon)) return true;
            if (product._brandHandle && (product._brandHandle === resolved.handle || normalize(product._brandHandle) === normalize(resolved.handle))) return true;
            if (pCanon.includes(qCanon)) return true;
            return false;
          }

          // 2. Canonical substring match (e.g. gshock matches g-shock):
          if (pCanon.includes(qCanon)) return true;

          // 3. Multi-token match (all tokens present):
          let allTokens = true;
          for (let i = 0; i < qTokens.length; i++) {
            if (!pCanon.includes(qTokens[i])) {
              allTokens = false;
              break;
            }
          }
          return allTokens;
        });

        return cachedContextualProducts;
      }

      const rawQuery = String(urlParams.get('q') || '').trim();
      const cleanQuery = rawQuery.replace(/\*/g, '').replace(/\bAND\b/gi, ' ').trim();
      const queryTerm = normalize(cleanQuery);
      const queryWords = queryTerm.split(/[\s-]+/).filter(function(w) {
        return Boolean(w) && w !== 'and' && w !== 'or';
      });

      if (!queryWords.length) {
        cachedContextualProducts = baseProducts;
        return cachedContextualProducts;
      }

      cachedContextualProducts = baseProducts.filter(function(product) {
        const sStr = product._searchStr || '';
        for (let i = 0; i < queryWords.length; i++) {
          if (!sStr.includes(queryWords[i])) return false;
        }
        return true;
      });

      return cachedContextualProducts;
    };

    function getCanonicalBrandName(name) {
      const norm = normalize(name);
      if (norm === 'bvlgari' || norm === 'bulgari') return 'Bulgari';
      if (norm === 'timestone' || norm === 'times-tone') return 'TIMESTONE';
      if (norm === 'g-shock') return 'G Shock';
      return name;
    }

    function getCanonicalHandle(handle) {
      const norm = normalize(handle);
      if (norm === 'bvlgari' || norm === 'bulgari') return 'bulgari';
      if (norm === 'timestone' || norm === 'times-tone') return 'timestone';
      if (norm === 'automatic-metal' || norm === 'automatic-metal-edition') return 'automatic-metal';
      if (norm === 'auto-leather-silicon' || norm === 'automatic-leather-silicon') return 'auto-leather-silicon';
      if (norm === 'girls-collection' || norm === 'girls' || norm === 'girl-s') return 'girls-collection';
      if (norm === 'sporty' || norm === 'sporty-33' || norm === 'sporty-models') return 'sporty';
      return norm;
    }

    // Fully context-aware category provider: computes exact intersections against active result set
    let cachedAvailableCategories = null;
    const getAvailableCategories = () => {
      if (cachedAvailableCategories !== null) return cachedAvailableCategories;

      const onCollectionPage = isCollectionPage();
      const currentHandle = currentCollectionHandle();
      const canonCurrentHandle = currentHandle ? getCanonicalHandle(currentHandle) : '';
      const heroTitleEl = document.querySelector('.collection-hero .section-title, .section-title');
      const currentTitle = heroTitleEl ? heroTitleEl.textContent.trim() : '';
      const isAllCollection = onCollectionPage && (!currentHandle || currentHandle === 'all' || currentHandle === 'all-products' || currentHandle === 'frontpage' || currentHandle === 'catalog');

      // 1. If on New Arrivals (/collections/all) with no secondary filters active:
      // Return all active collections with authoritative totals from live Shopify collections
      if (isAllCollection && selected.size === 0 && Array.isArray(window.RW_LIVE_COLLECTIONS) && window.RW_LIVE_COLLECTIONS.length > 0) {
        const activeCategories = [];
        const seenKeys = new Set();
        const excludedHandles = new Set(['all', 'frontpage', 'all-products', 'catalog']);

        for (let i = 0; i < window.RW_LIVE_COLLECTIONS.length; i++) {
          const col = window.RW_LIVE_COLLECTIONS[i];
          if (!col || !col.handle) continue;
          const h = col.handle;
          const canonH = getCanonicalHandle(h);
          if (excludedHandles.has(h) || excludedHandles.has(canonH)) continue;
          const count = Number(col.count || 0);
          if (count <= 0) continue;

          const title = getCanonicalBrandName(col.title || h);
          const key = normalize(title);
          if (seenKeys.has(key)) continue;
          seenKeys.add(key);

          activeCategories.push({
            title: title,
            handle: h,
            count: count
          });
        }

        activeCategories.sort(function(a, b) { return a.title.localeCompare(b.title); });
        cachedAvailableCategories = activeCategories;
        return cachedAvailableCategories;
      }

      // 2. Contextual Facets: compute against Base Scope products
      const contextualProducts = getContextualProducts();
      if (!contextualProducts || !contextualProducts.length) return [];

      const excludedHandles = new Set([
        'all', 'all-products', 'frontpage', 'catalog', 'video', 'click',
        'box-photo', 'og-box', 'custom', 'hd-video-all', 'live-data-girls',
        'click-data-girl-s', 'click-data-premium-1', 'click-auto-metal',
        'live-data-automatic-metal', 'live-data-leather-silicon', 'live-data-automatic-leather',
        'live-data-sporty', 'click-data-auto-leather', 'click-data-lether', 'click-data-sporty',
        'required-r3', 'required-r5', 'r-watches-ngp', 'r-watches', 'rwatches', 'ap', 'rm', 'ck', 'ax', 'lv'
      ]);

      const categoryMetaMap = new Map();

      // Collect all candidate categories present within current base contextual products
      for (let i = 0; i < contextualProducts.length; i++) {
        const product = contextualProducts[i];
        const cats = product.categories || [];

        for (let j = 0; j < cats.length; j++) {
          const cat = cats[j];
          if (!cat || !cat.handle) continue;
          const canonH = getCanonicalHandle(cat.handle);
          if (excludedHandles.has(cat.handle) || excludedHandles.has(canonH)) continue;
          if (onCollectionPage && currentHandle && isSameBrandOrCollection(cat.handle, cat.title, currentHandle, currentTitle)) continue;

          const title = getCanonicalBrandName(cat.title || cat.handle);
          const key = normalize(title);
          if (!categoryMetaMap.has(key)) {
            categoryMetaMap.set(key, {
              title: title,
              handle: canonH
            });
          }
        }
      }

      // Compute base count for each candidate category within base contextual products
      const activeCategories = [];

      categoryMetaMap.forEach(function(meta, key) {
        let count = 0;
        const targetHandle = meta.handle;
        const targetNorm = normalize(meta.title);

        for (let i = 0; i < contextualProducts.length; i++) {
          const product = contextualProducts[i];
          const hasCat = product._catSet && (product._catSet.has(targetHandle) || product._catSet.has(targetNorm) || (product.categories && product.categories.some(c => getCanonicalHandle(c.handle) === targetHandle || normalize(c.title) === targetNorm)));
          if (hasCat) {
            count++;
          }
        }

        const isSelected = selected.has(meta.handle) || selected.has(normalize(meta.handle)) || selected.has(targetNorm);
        // Display all secondary categories associated with the base collection (count > 0), OR currently selected
        if (count > 0 || isSelected) {
          activeCategories.push({
            title: meta.title,
            handle: meta.handle,
            count: count
          });
        }
      });

      activeCategories.sort(function(a, b) {
        if (b.count !== a.count) return b.count - a.count;
        return a.title.localeCompare(b.title);
      });

      cachedAvailableCategories = activeCategories;
      return cachedAvailableCategories;
    };

    function generatePriceBuckets(prices) {
      if (!prices || prices.length === 0) return [];

      const sorted = prices.slice().sort(function(a, b) { return a - b; });
      const minP = sorted[0];
      const maxP = sorted[sorted.length - 1];
      const uniquePrices = Array.from(new Set(sorted));

      const formatInr = function(val) {
        return '₹' + Math.round(val).toLocaleString('en-IN');
      };

      if (minP === maxP) {
        return [{
          min: minP,
          max: maxP,
          key: `${minP}-${maxP}`,
          count: prices.length,
          label: formatInr(minP)
        }];
      }

      if (uniquePrices.length <= 3) {
        const buckets = [];
        for (let i = 0; i < uniquePrices.length; i++) {
          const u = uniquePrices[i];
          let bMin, bMax;
          if (i === 0) {
            bMin = u;
            bMax = uniquePrices.length > 1 ? Math.floor((u + uniquePrices[1]) / 2) : u;
          } else if (i === uniquePrices.length - 1) {
            bMin = Math.floor((uniquePrices[i - 1] + u) / 2) + 1;
            bMax = u;
          } else {
            bMin = Math.floor((uniquePrices[i - 1] + u) / 2) + 1;
            bMax = Math.floor((u + uniquePrices[i + 1]) / 2);
          }
          const count = sorted.filter(function(p) { return p >= bMin && p <= bMax; }).length;
          if (count > 0) {
            buckets.push({
              min: bMin,
              max: bMax,
              key: `${bMin}-${bMax}`,
              count: count,
              label: `${formatInr(bMin)} – ${formatInr(bMax)}`
            });
          }
        }
        return buckets;
      }

      const spread = maxP - minP;

      const candidateSteps = [
        50, 100, 200, 250, 500, 1000, 2000, 2500, 5000,
        10000, 20000, 25000, 50000, 100000, 200000, 250000, 500000
      ];

      let bestStep = candidateSteps[0];
      let bestBucketCountDiff = 999;
      const targetCount = 5;

      for (let s = 0; s < candidateSteps.length; s++) {
        const step = candidateSteps[s];
        const start = Math.floor(minP / step) * step;
        const end = Math.ceil(maxP / step) * step;
        const numBuckets = Math.round((end - start) / step);
        if (numBuckets >= 3 && numBuckets <= 7) {
          const diff = Math.abs(numBuckets - targetCount);
          if (diff < bestBucketCountDiff) {
            bestBucketCountDiff = diff;
            bestStep = step;
          }
        }
      }

      if (bestBucketCountDiff === 999) {
        const rawStep = spread / targetCount;
        let minDiff = Infinity;
        for (let s = 0; s < candidateSteps.length; s++) {
          const step = candidateSteps[s];
          const diff = Math.abs(step - rawStep);
          if (diff < minDiff) {
            minDiff = diff;
            bestStep = step;
          }
        }
      }

      let startBound = Math.floor(minP / bestStep) * bestStep;
      if (startBound < 0) startBound = 0;

      const rawBuckets = [];
      let curr = startBound;
      while (curr < maxP) {
        const next = curr + bestStep;
        rawBuckets.push({ min: curr === startBound ? minP : (curr + 1), max: next });
        curr = next;
      }

      if (rawBuckets.length > 0) {
        rawBuckets[rawBuckets.length - 1].max = Math.max(rawBuckets[rawBuckets.length - 1].max, maxP);
      }

      const populatedBuckets = [];
      for (let i = 0; i < rawBuckets.length; i++) {
        const b = rawBuckets[i];
        const count = sorted.filter(function(p) { return p >= b.min && p <= b.max; }).length;
        if (count > 0) {
          populatedBuckets.push({ min: b.min, max: b.max, count: count });
        }
      }

      for (let i = 0; i < populatedBuckets.length; i++) {
        if (i === 0) {
          populatedBuckets[i].min = minP;
        }
        if (i === populatedBuckets.length - 1) {
          populatedBuckets[i].max = maxP;
        } else {
          populatedBuckets[i + 1].min = populatedBuckets[i].max + 1;
        }
      }

      return populatedBuckets.map(function(b) {
        const c = sorted.filter(function(p) { return p >= b.min && p <= b.max; }).length;
        return {
          min: b.min,
          max: b.max,
          key: `${b.min}-${b.max}`,
          count: c,
          label: `${formatInr(b.min)} – ${formatInr(b.max)}`
        };
      });
    }

    // Render dynamic price checkboxes and sync active state
    const renderPriceFilter = (categorySetOverride = null) => {
      const contextualProducts = getContextualProducts();
      // DO NOT FILTER PRICE AGAINST ITSELF:
      // Base collection + category + other active non-price filters determine available price options
      const activeCatSet = categorySetOverride !== null ? categorySetOverride : selected;
      const hasCategoryFilter = activeCatSet.size > 0;
      const applicableProducts = hasCategoryFilter
        ? contextualProducts.filter(function(product) {
            for (const sel of activeCatSet) {
              const selNorm = normalize(sel);
              const selCanon = getCanonicalHandle(sel);
              if (product._catSet && (product._catSet.has(sel) || product._catSet.has(selNorm) || product._catSet.has(selCanon))) return true;
            }
            return false;
          })
        : contextualProducts;

      const validPrices = applicableProducts.map(function(p) { return p._price || 0; }).filter(function(p) { return p > 0; });
      const buckets = generatePriceBuckets(validPrices);

      // Cleanse invalid selected price ranges if applicable products price distribution shifted
      if (selectedPriceRanges.size > 0 && applicableProducts.length > 0) {
        const validRangeKeys = new Set();
        selectedPriceRanges.forEach(function(key) {
          const r = parsePriceRangeKey(key);
          if (r) {
            const hasMatch = applicableProducts.some(function(p) {
              const price = p._price || 0;
              return price >= r.min && price <= r.max;
            });
            if (hasMatch) {
              validRangeKeys.add(key);
            }
          }
        });
        selectedPriceRanges.clear();
        validRangeKeys.forEach(function(k) { selectedPriceRanges.add(k); });
      }

      const priceLists = document.querySelectorAll('[data-dynamic-price-list], [data-price-choice-list]');
      priceLists.forEach(function(list) {
        if (!buckets.length) {
          list.innerHTML = '<div style="font-size: 13px; color: #888; padding: 6px 0;">No price options available</div>';
          return;
        }

        list.innerHTML = buckets.map(function(b) {
          let isChecked = selectedPriceRanges.has(b.key);
          if (!isChecked && selectedPriceRanges.size > 0) {
            for (const key of selectedPriceRanges) {
              const r = parsePriceRangeKey(key);
              if (r && ((r.min >= b.min && r.min <= b.max) || (r.max >= b.min && r.max <= b.max) || (b.min >= r.min && b.max <= r.max))) {
                isChecked = true;
                break;
              }
            }
          }

          return '<label class="price-choice ' + (isChecked ? 'is-active' : '') + '">' +
            '<input type="checkbox" value="' + escapeHtml(b.key) + '" data-price-dynamic-input data-min="' + b.min + '" data-max="' + b.max + '" ' + (isChecked ? 'checked' : '') + '>' +
            '<span>' + escapeHtml(b.label) + '</span>' +
            '<small class="filter-chip__count">(' + b.count + ')</small>' +
            '</label>';
        }).join('');
      });
    };

    let userExplicitSort = null;
    const getSelectedSort = () => {
      if (userExplicitSort !== null) return userExplicitSort;
      const urlSort = new URLSearchParams(window.location.search).get('sort_by');
      if (urlSort) return urlSort;
      return 'manual';
    };

    const pureRandomProductShuffle = (items) => {
      const arr = items.slice();
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = arr[i];
        arr[i] = arr[j];
        arr[j] = temp;
      }
      return arr;
    };

    let currentShuffledProducts = null;
    let lastContextualKey = '';

    const getMatchingProducts = (forceReshuffle = false) => {
      const contextualProducts = getContextualProducts();
      if (!contextualProducts.length) return [];

      const hasCategoryFilter = selected.size > 0;
      const currentSort = getSelectedSort();

      let filtered = contextualProducts.filter(function(product) {
        if (hasCategoryFilter) {
          let matched = false;
          for (const sel of selected) {
            const selNorm = normalize(sel);
            const selCanon = getCanonicalHandle(sel);
            if (product._catSet && (product._catSet.has(sel) || product._catSet.has(selNorm) || product._catSet.has(selCanon))) {
              matched = true;
              break;
            }
          }
          if (!matched) return false;
        }

        if (selectedPriceRanges.size > 0) {
          const price = product._price || 0;
          let matchedPrice = false;
          for (const key of selectedPriceRanges) {
            const r = parsePriceRangeKey(key);
            if (r && price >= r.min && price <= r.max) {
              matchedPrice = true;
              break;
            }
          }
          if (!matchedPrice) return false;
        }

        return true;
      });

      if (currentSort === 'created-descending') {
        filtered.sort(function(a, b) {
          const tA = a._timestamp || 0;
          const tB = b._timestamp || 0;
          if (tB !== tA) return tB - tA;
          return String(b.handle || '').localeCompare(String(a.handle || ''));
        });
        currentShuffledProducts = filtered;
      } else if (currentSort === 'price-ascending') {
        filtered.sort(function(a, b) { return (a._price || 0) - (b._price || 0); });
        currentShuffledProducts = filtered;
      } else if (currentSort === 'price-descending') {
        filtered.sort(function(a, b) { return (b._price || 0) - (a._price || 0); });
        currentShuffledProducts = filtered;
      } else if (currentSort === 'discount-desc') {
        filtered.sort(function(a, b) { return (b._discount || 0) - (a._discount || 0); });
        currentShuffledProducts = filtered;
      } else {
        const contextKey = window.location.pathname + '-' + Array.from(selected).sort().join(',') + '-' + Array.from(selectedPriceRanges).sort().join(',');
        if (forceReshuffle || !currentShuffledProducts || lastContextualKey !== contextKey) {
          lastContextualKey = contextKey;
          currentShuffledProducts = pureRandomProductShuffle(filtered);
        }
        return currentShuffledProducts;
      }

      return filtered;
    };

    const renderCardHtml = (product) => {
      const productUrl = safeProductUrl(product);
      const title = escapeHtml(product.title || '');
      const priceNum = product._price !== undefined ? product._price : Number(product.price || 0);
      const compareNum = product._comparePrice !== undefined ? product._comparePrice : Number(product.compareAtPrice || 0);
      const price = moneyInr(priceNum);
      const comparePrice = compareNum > priceNum ? moneyInr(compareNum) : '';
      const saved = product._discount !== undefined ? product._discount : (compareNum > priceNum ? Math.round(((compareNum - priceNum) * 100) / compareNum) : 0);
      const variantId = product.variants?.[0]?.id || product.variantId || product.variant_id || product.id || '';
      const isAvailable = product.available !== false;

      const rawImages = Array.isArray(product.images) && product.images.length
        ? product.images.map(function(img) { return typeof img === 'string' ? img : (img?.src || img?.url); }).filter(Boolean)
        : [product.image, product.hoverImage].filter(Boolean);

      const imagesList = Array.from(new Set(rawImages));

      const slidesHtml = imagesList.map(function(imgUrl, i) {
        return '<a class="product-card__media-slide" href="' + productUrl + '" aria-label="View ' + title + ' slide ' + (i + 1) + '">' +
          '<img class="primary" src="' + escapeHtml(hdImageUrl(imgUrl)) + '" alt="' + title + '" loading="lazy" sizes="(max-width: 749px) 50vw, 320px" width="320" height="400">' +
        '</a>';
      }).join('');

      const categoryLabels = (product.categories || []).map(function(c) { return c.title; }).join('||');
      const categoryValues = (product.categories || []).map(function(c) { return c.handle; }).join('||');

      const actionBtn = isAvailable && variantId
        ? '<form method="post" action="' + (window.Shopify?.routes?.root || '/') + 'cart/add" data-ajax-cart-form style="width: 100%; margin-top: auto;">' +
            '<input type="hidden" name="id" value="' + escapeHtml(String(variantId)) + '">' +
            '<input type="hidden" name="quantity" value="1">' +
            '<button class="button" type="submit">Add to cart</button>' +
          '</form>'
        : '<a class="button" href="' + productUrl + '" style="width: 100%; margin-top: auto;">Add to cart</a>';

      return '<article class="product-card" data-product-card ' +
        'data-product-handle="' + escapeHtml(product.handle || '') + '" ' +
        'data-product-title="' + title + '" ' +
        'data-product-id="' + escapeHtml(String(product.id || variantId || '')) + '" ' +
        'data-product-price="' + escapeHtml(String(priceNum)) + '" ' +
        'data-product-compare="' + escapeHtml(String(compareNum)) + '" ' +
        'data-product-category="' + escapeHtml(product.productType || product.type || product.vendor || '') + '" ' +
        'data-product-type="' + escapeHtml(product.productType || product.type || '') + '" ' +
        'data-product-vendor="' + escapeHtml(product.vendor || '') + '" ' +
        'data-product-collections="' + escapeHtml(categoryValues) + '" ' +
        'data-product-category-labels="' + escapeHtml(categoryLabels) + '" ' +
        'data-product-category-values="' + escapeHtml(categoryValues) + '" ' +
        'data-product-created="' + escapeHtml(product.createdAt || '') + '" ' +
        'data-product-updated="' + escapeHtml(product.updatedAt || '') + '" ' +
        'data-product-published="' + escapeHtml(product.publishedAt || '') + '">' +
        '<div class="product-card__media" data-product-card-carousel>' +
          '<div class="product-card__media-track" data-product-card-track aria-label="Product media for ' + title + '">' +
            slidesHtml +
          '</div>' +
        '</div>' +
        '<div class="product-card__info">' +
          '<h3 class="product-card__title" title="' + title + '"><a href="' + productUrl + '">' + title + '</a></h3>' +
          '<div class="price-row">' +
            '<span class="price">' + price + '</span>' +
            (comparePrice ? '<span class="compare-price">' + comparePrice + '</span>' : '') +
          '</div>' +
          (saved > 0 ? '<span class="product-card__discount">' + saved + '% OFF</span>' : '<div style="margin-bottom:8px;"></div>') +
          actionBtn +
        '</div>' +
      '</article>';
    };

    const renderCategories = () => {
      const availableCategories = getAvailableCategories();
      const search = normalize(categorySearchTerm);
      const filteredCategories = search
        ? availableCategories.filter(function(c) { return normalize(c.title).includes(search) || normalize(c.handle).includes(search); })
        : availableCategories;

      const currentHandle = currentCollectionHandle();
      const canonCurrentHandle = currentHandle ? getCanonicalHandle(currentHandle) : '';

      lists.forEach(function(list) {
        let searchBox = list.previousElementSibling?.classList?.contains('filter-search-box') ? list.previousElementSibling : null;
        if (availableCategories.length > 8) {
          if (!searchBox) {
            searchBox = document.createElement('div');
            searchBox.className = 'filter-search-box';
            searchBox.style.cssText = 'margin-bottom: 10px; width: 100%;';
            searchBox.innerHTML = '<input type="text" placeholder="Search categories..." data-category-search-input style="width: 100%; padding: 7px 10px; font-size: 13px; border: 1px solid #ddd; border-radius: 6px; outline: none; box-sizing: border-box;" value="' + escapeHtml(categorySearchTerm) + '">';
            list.parentElement.insertBefore(searchBox, list);
          }
        } else if (searchBox) {
          searchBox.remove();
        }

        if (!filteredCategories.length) {
          list.innerHTML = '<div style="font-size: 13px; color: #888; padding: 6px 0;">No matching categories</div>';
          return;
        }

        list.innerHTML = filteredCategories.map(function(c) {
          const isChecked = selected.has(c.handle) || selected.has(normalize(c.handle)) || selected.has(normalize(c.title));
          return '<label class="filter-chip ' + (isChecked ? 'is-active' : '') + '">' +
            '<input type="checkbox" value="' + escapeHtml(c.handle) + '" data-category-dynamic-input ' + (isChecked ? 'checked' : '') + '>' +
            '<span>' + escapeHtml(c.title) + '</span>' +
            '<small class="filter-chip__count">(' + c.count + ')</small>' +
            '</label>';
        }).join('');
      });
    };

    function buildTargetFilterUrl(opts) {
      const clearAll = opts.clearAll;

      const currentUrl = new URL(window.location.href);
      const isSearch = currentUrl.pathname.includes('/search');
      const curHandle = currentCollectionHandle();
      const isAllCollection = !curHandle || curHandle === 'all' || curHandle === 'all-products' || curHandle === 'frontpage' || curHandle === 'catalog';

      // 1. Clear All: Return to Base Scope (preserve current collection or search)
      if (clearAll) {
        if (isSearch) {
          const next = new URL(window.location.pathname, window.location.origin);
          const q = currentUrl.searchParams.get('q');
          if (q) next.searchParams.set('q', q);
          const type = currentUrl.searchParams.get('type') || 'product';
          next.searchParams.set('type', type);
          return next.toString();
        } else {
          // Stay on current base collection! (e.g. /collections/rolex)
          return window.location.origin + currentUrl.pathname;
        }
      }

      // 2. Determine target path:
      let nextPath = currentUrl.pathname;
      let setCategoryParam = false;

      if (!isSearch) {
        if (isAllCollection) {
          const singleCat = opts.categoryHandle || (Array.isArray(opts.categoryHandles) && opts.categoryHandles.length === 1 ? opts.categoryHandles[0] : '');
          if (singleCat && singleCat !== 'all') {
            nextPath = '/collections/' + encodeURIComponent(singleCat);
          } else {
            nextPath = '/collections/all';
            setCategoryParam = true;
          }
        } else {
          // Inside a specific base collection: PRESERVE BASE COLLECTION PATH
          nextPath = currentUrl.pathname;
          setCategoryParam = true;
        }
      } else {
        // Search page: PRESERVE SEARCH PATH
        nextPath = currentUrl.pathname;
        setCategoryParam = true;
      }

      const nextUrl = new URL(nextPath, window.location.origin);

      if (isSearch) {
        const q = currentUrl.searchParams.get('q');
        if (q) nextUrl.searchParams.set('q', q);
        const type = currentUrl.searchParams.get('type') || 'product';
        nextUrl.searchParams.set('type', type);
      }

      const sortBy = currentUrl.searchParams.get('sort_by');
      if (sortBy && sortBy !== 'manual' && sortBy !== 'best-selling') {
        nextUrl.searchParams.set('sort_by', sortBy);
      }

      if (setCategoryParam) {
        if (opts.categoryHandles !== undefined) {
          const arr = Array.isArray(opts.categoryHandles) ? opts.categoryHandles : [opts.categoryHandles];
          const valid = arr.filter(Boolean).filter(function(h) { return h !== curHandle && h !== 'all'; });
          if (valid.length > 0) {
            nextUrl.searchParams.set('rw_category', valid.join(','));
          } else {
            nextUrl.searchParams.delete('rw_category');
          }
        } else if (opts.categoryHandle !== undefined) {
          if (opts.categoryHandle && opts.categoryHandle !== curHandle && opts.categoryHandle !== 'all' && opts.isChecked !== false) {
            nextUrl.searchParams.set('rw_category', opts.categoryHandle);
          } else {
            nextUrl.searchParams.delete('rw_category');
          }
        } else {
          const curCat = currentUrl.searchParams.get('rw_category');
          if (curCat) nextUrl.searchParams.set('rw_category', curCat);
        }
      }

      if (opts.priceRanges !== undefined) {
        const arr = Array.isArray(opts.priceRanges) ? opts.priceRanges : (opts.priceRanges ? [opts.priceRanges] : []);
        const valid = arr.map(function(r) { return typeof r === 'string' ? r : (r ? `${r.min}-${r.max}` : ''); }).filter(Boolean);
        if (valid.length > 0) {
          nextUrl.searchParams.set('rw_price_ranges', valid.join(','));
          const mins = valid.map(function(k) { return Number(k.split('-')[0]); }).filter(function(n) { return !isNaN(n); });
          const maxs = valid.map(function(k) { return Number(k.split('-')[1]); }).filter(function(n) { return !isNaN(n); });
          if (mins.length && maxs.length) {
            nextUrl.searchParams.set('filter.v.price.gte', String(Math.min(...mins)));
            nextUrl.searchParams.set('filter.v.price.lte', String(Math.max(...maxs)));
          }
        } else {
          nextUrl.searchParams.delete('rw_price_ranges');
          nextUrl.searchParams.delete('filter.v.price.gte');
          nextUrl.searchParams.delete('filter.v.price.lte');
          nextUrl.searchParams.delete('rw_price_min');
          nextUrl.searchParams.delete('rw_price_max');
        }
      } else {
        const curRanges = currentUrl.searchParams.get('rw_price_ranges');
        if (curRanges) nextUrl.searchParams.set('rw_price_ranges', curRanges);
        const curGte = currentUrl.searchParams.get('filter.v.price.gte');
        if (curGte) nextUrl.searchParams.set('filter.v.price.gte', curGte);
        const curLte = currentUrl.searchParams.get('filter.v.price.lte');
        if (curLte) nextUrl.searchParams.set('filter.v.price.lte', curLte);
      }

      return nextUrl.toString();
    }

    const renderGrid = (resetLimit = true) => {
      if (resetLimit) currentRenderLimit = 30;
      const matching = getMatchingProducts(resetLimit);
      lastFilteredProducts = matching;
      const visible = matching.slice(0, currentRenderLimit);
      if (visible.length) {
        grid.innerHTML = visible.map(renderCardHtml).join('');
        if (typeof initProductCardCarousels === 'function') {
          initProductCardCarousels(grid);
        }
      } else {
        grid.innerHTML = '<div class="empty-state" style="grid-column: 1 / -1; text-align: center; padding: 48px 16px;"><p>No products match the selected filters.</p></div>';
      }

      // Update infinite load controls
      const controls = grid.parentElement?.querySelector('[data-infinite-controls]') || document.querySelector('[data-infinite-controls]');
      if (controls) {
        const btn = controls.querySelector('[data-infinite-button]');
        const status = controls.querySelector('[data-infinite-status]');
        if (btn) btn.style.display = 'none';
        if (status) status.textContent = '';
        if (matching.length > currentRenderLimit) {
          controls.removeAttribute('hidden');
          controls.style.display = '';
          if (typeof window.rwReconnectInfiniteObserver === 'function') {
            window.rwReconnectInfiniteObserver();
          }
        } else {
          // Terminal state: all products fit in current limit (or 0 results)
          controls.setAttribute('hidden', 'true');
          controls.style.display = 'none';
          if (typeof window.rwDisconnectInfiniteObserver === 'function') {
            window.rwDisconnectInfiniteObserver();
          }
        }
      }
    };

    window.rwLoadMoreFiltered = () => {
      const matching = lastFilteredProducts;
      if (!matching || !matching.length) return;
      if (currentRenderLimit < matching.length) {
        currentRenderLimit += 30;
        const prevCount = grid.querySelectorAll('[data-product-card]').length;
        const nextBatch = matching.slice(prevCount, currentRenderLimit);
        if (nextBatch.length) {
          const temp = document.createElement('div');
          temp.innerHTML = nextBatch.map(renderCardHtml).join('');
          const existingIds = new Set(
            Array.from(grid.querySelectorAll('[data-product-card]'))
              .map(c => c.dataset.productHandle || c.dataset.productId)
              .filter(Boolean)
          );
          Array.from(temp.children).forEach(card => {
            const cid = card.dataset.productHandle || card.dataset.productId;
            if (cid && existingIds.has(cid)) return;
            if (cid) existingIds.add(cid);
            grid.appendChild(card);
          });
          if (typeof initProductCardCarousels === 'function') {
            initProductCardCarousels(grid);
          }
          document.dispatchEvent(new CustomEvent('rwatches:products-loaded'));
        }
      }

      const controls = grid.parentElement?.querySelector('[data-infinite-controls]') || document.querySelector('[data-infinite-controls]');
      if (controls) {
        const btn = controls.querySelector('[data-infinite-button]');
        const status = controls.querySelector('[data-infinite-status]');
        if (btn) btn.style.display = 'none';
        if (currentRenderLimit >= matching.length) {
          // TERMINAL STATE: All filtered products loaded
          controls.setAttribute('hidden', 'true');
          controls.style.display = 'none';
          if (status) status.textContent = '';
          if (typeof window.rwDisconnectInfiniteObserver === 'function') {
            window.rwDisconnectInfiniteObserver();
          }
        } else {
          controls.removeAttribute('hidden');
          controls.style.display = '';
          if (status) status.textContent = '';
        }
      }
    };

    let isFilterNavigating = false;
    const loadFilteredUrl = async (targetUrl, pushState = true) => {
      if (isFilterNavigating) return;
      isFilterNavigating = true;

      const grid = document.querySelector('#CollectionProductsGrid, #SearchProductsGrid, [data-collection-grid]');
      if (!grid) {
        window.location.href = targetUrl;
        return;
      }

      const currentUrl = new URL(window.location.href);
      const targetObj = new URL(targetUrl, window.location.origin);
      const samePath = targetObj.pathname === currentUrl.pathname;

      if (samePath) {
        if (pushState) {
          if (window.location.hash) {
            window.history.replaceState({}, '', targetUrl);
          } else {
            window.history.pushState({}, '', targetUrl);
          }
        } else {
          window.history.replaceState({}, '', targetUrl);
        }

        syncStateFromUrl();

        const hasActiveFilter = selected.size > 0 || selectedPriceRanges.size > 0;
        const curCol = currentCollectionHandle();

        if (hasActiveFilter && hasMoreCollectionPages() && curCol && !fullCollectionScopeCache.has(curCol)) {
          grid.style.opacity = '0.5';
          grid.style.pointerEvents = 'none';
          await fetchCompleteCollectionScope(curCol);
          cachedContextualProducts = null;
          cachedAvailableCategories = null;
          grid.style.opacity = '1';
          grid.style.pointerEvents = '';
        }

        if (hasActiveFilter) {
          grid.setAttribute('data-filtered-rendered', 'true');
          grid.dataset.nextUrl = '';
          renderGrid(true);
          const matching = getMatchingProducts();
          document.querySelectorAll('.collection-toolbar__summary span:first-child').forEach(function(el) {
            el.textContent = matching.length + ' products';
          });
          document.querySelectorAll('.section-title__count').forEach(function(el) {
            el.textContent = '(' + matching.length + ')';
          });
        } else {
          grid.removeAttribute('data-filtered-rendered');
          const initialCards = parseInitialDomCards();
          grid.innerHTML = initialCards.map(renderCardHtml).join('');
          document.querySelectorAll('.collection-toolbar__summary span:first-child').forEach(function(el) {
            el.textContent = initialCards.length + ' products';
          });
          document.querySelectorAll('.section-title__count').forEach(function(el) {
            el.textContent = '(' + initialCards.length + ')';
          });
          if (typeof initProductCardCarousels === 'function') {
            initProductCardCarousels(grid);
          }
          const controls = grid.parentElement?.querySelector('[data-infinite-controls]') || document.querySelector('[data-infinite-controls]');
          if (controls) {
            const btn = controls.querySelector('[data-infinite-button]');
            const status = controls.querySelector('[data-infinite-status]');
            if (btn) btn.style.display = 'none';
            if (status) status.textContent = '';
            if (initialGridNextUrl) {
              grid.dataset.nextUrl = initialGridNextUrl;
              controls.removeAttribute('hidden');
              controls.style.display = '';
              if (typeof window.rwReconnectInfiniteObserver === 'function') {
                window.rwReconnectInfiniteObserver();
              }
            } else {
              controls.setAttribute('hidden', 'true');
              controls.style.display = 'none';
              if (typeof window.rwDisconnectInfiniteObserver === 'function') {
                window.rwDisconnectInfiniteObserver();
              }
            }
          }
        }

        cachedAvailableCategories = null;
        renderCategories();
        renderPriceFilter();

        isFilterNavigating = false;
        return;
      }

      // Different pathname: execute smooth AJAX load to switch base collection
      grid.style.opacity = '0.5';
      grid.style.pointerEvents = 'none';

      try {
        const response = await fetch(targetUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Fetch failed with status ' + response.status);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const nextGrid = doc.querySelector('#CollectionProductsGrid, #SearchProductsGrid, [data-collection-grid]');
        if (!nextGrid) throw new Error('New grid not found in response');

        grid.innerHTML = nextGrid.innerHTML;
        grid.removeAttribute('data-filtered-rendered');
        grid.dataset.loading = 'false';

        if (nextGrid.dataset.nextUrl) {
          grid.dataset.nextUrl = nextGrid.dataset.nextUrl;
        } else {
          grid.removeAttribute('data-next-url');
        }

        const nextTitle = doc.querySelector('.collection-hero .section-title, .search-results-page .section-title');
        const curTitle = document.querySelector('.collection-hero .section-title, .search-results-page .section-title');
        if (nextTitle && curTitle) {
          curTitle.innerHTML = nextTitle.innerHTML;
        }

        const nextSummary = doc.querySelector('.collection-toolbar__summary');
        const curSummary = document.querySelector('.collection-toolbar__summary');
        if (nextSummary && curSummary) {
          curSummary.innerHTML = nextSummary.innerHTML;
        }

        const controls = grid.parentElement?.querySelector('[data-infinite-controls]') || document.querySelector('[data-infinite-controls]');
        if (controls) {
          const btn = controls.querySelector('[data-infinite-button]');
          const status = controls.querySelector('[data-infinite-status]');
          if (btn) btn.style.display = 'none';
          if (status) status.textContent = '';
          if (grid.dataset.nextUrl) {
            controls.removeAttribute('hidden');
            controls.style.display = '';
            if (typeof window.rwReconnectInfiniteObserver === 'function') {
              window.rwReconnectInfiniteObserver();
            }
          } else {
            controls.setAttribute('hidden', 'true');
            controls.style.display = 'none';
            if (typeof window.rwDisconnectInfiniteObserver === 'function') {
              window.rwDisconnectInfiniteObserver();
            }
          }
        }

        if (pushState) {
          window.history.pushState({}, '', targetUrl);
        }

        syncStateFromUrl();

        // Reset caches for the new base collection
        cachedInitialDomProducts = null;
        cachedContextualProducts = null;
        cachedAvailableCategories = null;
        initialGridNextUrl = grid.dataset.nextUrl || '';
        parseInitialDomCards();

        if (typeof initProductCardCarousels === 'function') {
          initProductCardCarousels(grid);
        }
        document.dispatchEvent(new CustomEvent('rwatches:products-loaded'));

        renderCategories();
        renderPriceFilter();

        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (err) {
        console.warn('AJAX load failed, falling back to full navigation:', err);
        window.location.href = targetUrl;
      } finally {
        isFilterNavigating = false;
        if (grid) {
          grid.style.opacity = '1';
          grid.style.pointerEvents = '';
        }
      }
    };

    let lastHandledFilterSearch = window.location.search;
    window.addEventListener('popstate', function() {
      if (window.location.search === lastHandledFilterSearch) {
        return; // Protect infinite-scrolled grid from being wiped on drawer/modal hash changes
      }
      lastHandledFilterSearch = window.location.search;
      loadFilteredUrl(window.location.href, false);
    });

    window.rwRefreshFilters = () => {
      cachedContextualProducts = null;
      cachedAvailableCategories = null;
      renderCategories();
      renderPriceFilter();
    };

    // Restore sort UI from URL params on shared links
    const urlSortBy = urlParams.get('sort_by');
    if (urlSortBy) {
      userExplicitSort = urlSortBy;
      const sortSelect = document.querySelector('[data-collection-sort]');
      if (sortSelect) sortSelect.value = urlSortBy;
      document.querySelectorAll('input[data-sort-choice]').forEach(function(radio) {
        const isMatch = radio.value === urlSortBy;
        radio.checked = isMatch;
        radio.closest('.sort-choice')?.classList.toggle('is-active', isMatch);
      });
    } else {
      const sortSelect = document.querySelector('[data-collection-sort]');
      if (sortSelect) sortSelect.value = 'manual';
      document.querySelectorAll('input[data-sort-choice]').forEach(function(radio) {
        radio.checked = false;
        radio.closest('.sort-choice')?.classList.remove('is-active');
      });
    }

    // If initial URL has filter params, apply them immediately
    if (selected.size > 0 || selectedPriceRanges.size > 0) {
      const curCol = currentCollectionHandle();
      if (hasMoreCollectionPages() && curCol && !fullCollectionScopeCache.has(curCol)) {
        fetchCompleteCollectionScope(curCol).then(function() {
          cachedContextualProducts = null;
          cachedAvailableCategories = null;
          renderGrid(true);
          const matching = getMatchingProducts();
          document.querySelectorAll('.collection-toolbar__summary span:first-child').forEach(function(el) {
            el.textContent = matching.length + ' products';
          });
          document.querySelectorAll('.section-title__count').forEach(function(el) {
            el.textContent = '(' + matching.length + ')';
          });
          renderCategories();
          renderPriceFilter();
        });
      } else {
        grid.setAttribute('data-filtered-rendered', 'true');
        grid.dataset.nextUrl = '';
        renderGrid(true);
        const matching = getMatchingProducts();
        document.querySelectorAll('.collection-toolbar__summary span:first-child').forEach(function(el) {
          el.textContent = matching.length + ' products';
        });
        document.querySelectorAll('.section-title__count').forEach(function(el) {
          el.textContent = '(' + matching.length + ')';
        });
      }
    }

    // Initial render of categories and dynamic price ranges (respecting live server-rendered DOM)
    renderCategories();
    renderPriceFilter();

    // Search page query resolution: if query can be resolved to a canonical brand, normalize URL query
    if (window.location.pathname.includes('/search')) {
      const searchParams = new URLSearchParams(window.location.search);
      const rawQ = searchParams.get('q');
      const sGrid = document.querySelector('#SearchProductsGrid, [data-collection-grid]');
      const cardCount = sGrid ? sGrid.querySelectorAll('[data-product-card]').length : 0;

      if (rawQ) {
        const resolved = resolveSearchBrand(rawQ, window.RW_LIVE_COLLECTIONS);
        if (resolved) {
          const targetBrand = resolved.brand || resolved.handle;
          const formattedQ = targetBrand;
          const cleanRawQ = rawQ.replace(/["*]/g, '').trim().toLowerCase();
          const cleanTarget = targetBrand.replace(/["*]/g, '').trim().toLowerCase();
          if (cleanRawQ !== cleanTarget && rawQ !== formattedQ) {
            searchParams.set('q', formattedQ);
            if (!searchParams.has('type')) searchParams.set('type', 'product');
            const targetUrl = window.location.pathname + '?' + searchParams.toString();
            window.location.replace(targetUrl);
          }
        } else if (!rawQ.includes('*') && cardCount === 0) {
          const words = rawQ.trim().split(/\s+/).filter(Boolean);
          if (words.length > 0) {
            const wildcardQ = words.map(function(w) { return w.endsWith('*') ? w : (w + '*'); }).join(' ');
            searchParams.set('q', wildcardQ);
            if (!searchParams.has('type')) searchParams.set('type', 'product');
            const targetUrl = window.location.pathname + '?' + searchParams.toString();
            window.location.replace(targetUrl);
          }
        }
      }
    }

    // Category search input
    document.addEventListener('input', function(event) {
      const input = event.target.closest('[data-category-search-input]');
      if (input) {
        categorySearchTerm = input.value;
        renderCategories();
      }
    });

    // Category chip change
    document.addEventListener('change', function(event) {
      const input = event.target.closest('[data-category-dynamic-input]');
      if (!input) return;

      const isDrawer = input.closest('#CollectionFilterDrawer, #SearchFilterDrawer');
      if (isDrawer) {
        input.closest('.filter-chip')?.classList.toggle('is-active', input.checked);
        const checkedInputs = isDrawer.querySelectorAll('[data-category-dynamic-input]:checked');
        const draftCats = new Set(Array.from(checkedInputs).map(function(i) { return i.value; }).filter(Boolean));
        const checkedPrices = isDrawer.querySelectorAll('[data-price-dynamic-input]:checked');
        selectedPriceRanges.clear();
        checkedPrices.forEach(function(p) { if (p.value) selectedPriceRanges.add(p.value); });
        renderPriceFilter(draftCats);
        return;
      }

      // Desktop filter panel
      const desktopPanel = input.closest('.desktop-filter') || document.querySelector('.desktop-filter');
      const checkedInputs = desktopPanel ? desktopPanel.querySelectorAll('[data-category-dynamic-input]:checked') : [input];
      const selectedCats = Array.from(checkedInputs).map(function(i) { return i.value; }).filter(Boolean);

      const checkedPrices = desktopPanel ? desktopPanel.querySelectorAll('[data-price-dynamic-input]:checked') : document.querySelectorAll('.desktop-filter [data-price-dynamic-input]:checked');
      const selectedPriceKeys = Array.from(checkedPrices).map(function(i) { return i.value; }).filter(Boolean);

      const targetUrl = buildTargetFilterUrl({ categoryHandles: selectedCats, priceRanges: selectedPriceKeys });
      loadFilteredUrl(targetUrl);
    });

    // Dynamic price checkbox change
    document.addEventListener('change', function(event) {
      const input = event.target.closest('[data-price-dynamic-input]');
      if (!input) return;

      input.closest('.price-choice')?.classList.toggle('is-active', input.checked);

      const isDrawer = input.closest('#CollectionFilterDrawer, #SearchFilterDrawer');
      if (isDrawer) {
        if (input.checked) {
          selectedPriceRanges.add(input.value);
        } else {
          selectedPriceRanges.delete(input.value);
        }
        return;
      }

      // Desktop filter panel
      const desktopPanel = input.closest('.desktop-filter') || document.querySelector('.desktop-filter');
      const checkedCats = desktopPanel ? desktopPanel.querySelectorAll('[data-category-dynamic-input]:checked') : document.querySelectorAll('.desktop-filter [data-category-dynamic-input]:checked');
      const selectedCats = Array.from(checkedCats).map(function(i) { return i.value; }).filter(Boolean);

      const checkedPrices = desktopPanel ? desktopPanel.querySelectorAll('[data-price-dynamic-input]:checked') : [input];
      const selectedPriceKeys = Array.from(checkedPrices).map(function(i) { return i.value; }).filter(Boolean);

      const targetUrl = buildTargetFilterUrl({ categoryHandles: selectedCats, priceRanges: selectedPriceKeys });
      loadFilteredUrl(targetUrl);
    });

    // Drawer Apply Filters button
    document.addEventListener('click', function(event) {
      const applyBtn = event.target.closest('[data-filter-apply]');
      if (!applyBtn) return;
      event.preventDefault();

      const drawer = applyBtn.closest('#CollectionFilterDrawer, #SearchFilterDrawer') || document.querySelector('#CollectionFilterDrawer, #SearchFilterDrawer');
      if (!drawer) return;

      const checkedInputs = drawer.querySelectorAll('[data-category-dynamic-input]:checked');
      const selectedCats = Array.from(checkedInputs).map(function(i) { return i.value; }).filter(Boolean);

      const checkedPrices = drawer.querySelectorAll('[data-price-dynamic-input]:checked');
      const selectedPriceKeys = Array.from(checkedPrices).map(function(i) { return i.value; }).filter(Boolean);

      const targetUrl = buildTargetFilterUrl({ categoryHandles: selectedCats, priceRanges: selectedPriceKeys });
      closeDrawer(false, true);
      loadFilteredUrl(targetUrl);
    });

    // Clear all filters button
    document.addEventListener('click', function(event) {
      const btn = event.target.closest('[data-clear-all-filters]');
      if (!btn) return;
      event.preventDefault();
      selected.clear();
      selectedPriceRanges.clear();

      const targetUrl = buildTargetFilterUrl({ clearAll: true });
      closeDrawer(false, true);
      loadFilteredUrl(targetUrl);
    });

    // Sort change listener
    document.addEventListener('change', function(event) {
      const select = event.target.closest('[data-collection-sort]');
      if (!select) return;
      const targetUrl = new URL(window.location.href);
      if (select.value && select.value !== 'manual' && select.value !== 'best-selling') {
        targetUrl.searchParams.set('sort_by', select.value);
      } else {
        targetUrl.searchParams.delete('sort_by');
      }
      loadFilteredUrl(targetUrl.toString());
    });

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('[data-drawer-trigger]');
      if (!trigger || !String(trigger.dataset.drawerTrigger || '').includes('FilterDrawer')) return;
      syncStateFromUrl();
      const curCol = currentCollectionHandle();
      if (hasMoreCollectionPages() && curCol && !fullCollectionScopeCache.has(curCol)) {
        fetchCompleteCollectionScope(curCol).then(function() {
          cachedContextualProducts = null;
          cachedAvailableCategories = null;
          renderCategories();
          renderPriceFilter();
        });
      }
      renderCategories();
      renderPriceFilter();
    });

    // On multi-page collection pages, pre-fetch complete scope on idle
    if (isCollectionPage() && hasMoreCollectionPages()) {
      const prefetchIdle = () => {
        const curCol = currentCollectionHandle();
        if (curCol && !fullCollectionScopeCache.has(curCol)) {
          fetchCompleteCollectionScope(curCol).then(function() {
            cachedContextualProducts = null;
            cachedAvailableCategories = null;
            renderCategories();
            renderPriceFilter();
          });
        }
      };
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(prefetchIdle, { timeout: 2500 });
      } else {
        setTimeout(prefetchIdle, 1500);
      }
    }

    // Infinite auto load-more helper
    function triggerAutoLoad() {
      if (typeof window.rwTriggerInfiniteLoad === 'function') {
        window.rwTriggerInfiniteLoad();
      } else if (typeof window.rwLoadMoreFiltered === 'function') {
        window.rwLoadMoreFiltered();
      }
    }

    window.rwSetSort = (val) => { userExplicitSort = val; };
    window.rwRenderGrid = renderGrid;
    window.rwIsFiltered = () => (selected.size > 0 || selectedPriceRanges.size > 0 || grid.getAttribute('data-filtered-rendered') === 'true');
  }

  function initPriceChoices() {
    document.querySelectorAll('[data-price-choice-list]').forEach((list) => {
      const form = list.closest('form');
      const minField = form?.querySelector('[data-price-min-field]');
      const maxField = form?.querySelector('[data-price-max-field]');
      if (!form || !minField || !maxField) return;

      list.addEventListener('change', (event) => {
        const input = event.target.closest('[data-price-choice]');
        if (!input) return;
        list.querySelectorAll('[data-price-choice]').forEach((choice) => {
          if (choice !== input) choice.checked = false;
        });
        input.checked = true;
        minField.disabled = false;
        maxField.disabled = false;
        minField.value = input.dataset.min || '';
        maxField.value = input.dataset.max || '';
        list.querySelectorAll('.price-choice').forEach((choice) => {
          choice.classList.toggle('is-active', choice.contains(input));
        });
      });
    });
  }

  function initSortPages() {
    document.querySelectorAll('[data-sort-page-form]').forEach((form) => {
      form.addEventListener('change', (event) => {
        const input = event.target.closest('[data-sort-choice]');
        if (!input) return;
        form.querySelectorAll('.sort-choice').forEach((choice) => {
          choice.classList.toggle('is-active', choice.contains(input));
        });
        const matchingSelect = document.querySelector('[data-collection-sort]');
        if (matchingSelect) {
          matchingSelect.value = input.value;
        }
        sortProductGrid(input.value);
        if (!form.hasAttribute('data-client-sort') && typeof window.rwRenderGrid !== 'function') {
          form.submit();
        }
      });
    });
  }

  function sortProductGrid(value) {
    if (typeof window.rwSetSort === 'function') window.rwSetSort(value);
    if (typeof window.rwRenderGrid === 'function' && document.querySelector('[data-filtered-rendered="true"]')) {
      window.rwRenderGrid(true);
      return;
    }
    const grid = document.querySelector('[data-collection-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
    if (cards.length <= 1) return;

    if (!value || value === 'manual' || value === 'best-selling') {
      const brands = [
        'Audemars Piguet', 'Patek Philippe', 'Richard Mille', 'Armani Exchange', 'Calvin Klein',
        'Louis Vuitton', 'Tommy Hilfiger', 'Daniel Wellington', 'Vacheron Constantin', 'Franck Muller',
        'Roger Dubuis', 'Jacob Co', 'Sevenfriday', 'Michael Kors', 'Mont Blanc', 'Happy Time',
        'Rolex', 'Fossil', 'Tissot', 'Rado', 'Omega', 'Seiko', 'Casio', 'Citizen',
        'Armani', 'Cartier', 'Hublot', 'Tag Heuer', 'Diesel', 'Guess', 'Gucci', 'Chanel', 'Versace',
        'Swarovski', 'Burberry', 'Bulgari', 'Bvlgari', 'Movado', 'Hmt', 'Eora', 'Bistec', 'Curren',
        'Breitling', 'Corum', 'Edifice', 'G-Shock', 'G Shock', 'Dior', 'Chopard', 'Invicta',
        'AP', 'RM', 'CK', 'AX', 'LV'
      ];
      const buckets = {};
      cards.forEach((c) => {
        const titleEl = c.querySelector('.product-card__title a') || c.querySelector('.product-card__title');
        const title = (titleEl ? titleEl.textContent : '').toLowerCase();
        let foundBrand = 'Other';
        for (let i = 0; i < brands.length; i++) {
          const b = brands[i];
          const bLow = b.toLowerCase();
          if (b.length <= 3) {
            const regex = new RegExp('(?:^|[^a-z0-9])' + bLow + '(?:$|[^a-z0-9])', 'i');
            if (regex.test(title)) { foundBrand = b; break; }
          } else if (title.includes(bLow)) {
            foundBrand = b; break;
          }
        }
        if (!buckets[foundBrand]) buckets[foundBrand] = [];
        buckets[foundBrand].push(c);
      });

      const brandKeys = Object.keys(buckets);
      brandKeys.forEach((k) => {
        const b = buckets[k];
        for (let i = b.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const t = b[i]; b[i] = b[j]; b[j] = t;
        }
      });
      for (let i = brandKeys.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const t = brandKeys[i]; brandKeys[i] = brandKeys[j]; brandKeys[j] = t;
      }

      const shuffled = [];
      let hasItems = true;
      while (hasItems) {
        hasItems = false;
        for (let k = 0; k < brandKeys.length; k++) {
          const bucket = buckets[brandKeys[k]];
          if (bucket && bucket.length > 0) {
            shuffled.push(bucket.shift());
            hasItems = true;
          }
        }
      }
      shuffled.forEach((card) => grid.appendChild(card));
      return;
    }

    const sorter = {
      'created-descending': (a, b) => {
        const tA = getProductTimestamp(a);
        const tB = getProductTimestamp(b);
        if (tB !== tA) return tB - tA;
        return Number(b.dataset.originalIndex || 0) - Number(a.dataset.originalIndex || 0);
      },
      'price-ascending': (a, b) => Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0),
      'price-descending': (a, b) => Number(b.dataset.productPrice || 0) - Number(a.dataset.productPrice || 0),
      'discount-desc': (a, b) => Number(b.dataset.productDiscount || 0) - Number(a.dataset.productDiscount || 0)
    }[value] || ((a, b) => Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0));
    cards.sort(sorter).forEach((card) => grid.appendChild(card));
  }

  function initCollectionSorting() {
    const selects = Array.from(document.querySelectorAll('[data-collection-sort]'));
    const grid = document.querySelector('[data-collection-grid]');
    if (!selects.length || !grid) return;
    Array.from(grid.querySelectorAll('[data-product-card]')).forEach((card, index) => {
      if (!card.dataset.originalIndex) card.dataset.originalIndex = String(index);
    });
    selects.forEach((select) => {
      select.addEventListener('change', () => {
        selects.forEach((otherSelect) => {
          if (otherSelect !== select) otherSelect.value = select.value;
        });
        const radio = document.querySelector(`input[name="sort_by"][value="${select.value}"]`);
        if (radio) {
          radio.checked = true;
          radio.closest('form')?.querySelectorAll('.sort-choice').forEach((choice) => {
            choice.classList.toggle('is-active', choice.contains(radio));
          });
        }
        sortProductGrid(select.value);
      });
    });
  }

  function initProductCardCarousels(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-product-card-carousel]:not([data-carousel-ready])').forEach((carousel) => {
      if (carousel.closest('.cart-recommendations__scroller--cards, .top-selling-grid')) {
        carousel.dataset.carouselReady = 'true';
        return;
      }
      const track = carousel.querySelector('[data-product-card-track]');
      const slides = Array.from(carousel.querySelectorAll('.product-card__media-slide'));
      if (!track || !slides.length) return;
      carousel.dataset.carouselReady = 'true';
      let scrollFrame = null;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let didDrag = false;
      let touchStarted = false;
      let previewTimer = null;
      let previewStepTimer = null;
      let longPressTimer = null;
      let longPressDetected = false;

      const stopLongPressPreview = () => {
        if (previewTimer) window.clearTimeout(previewTimer);
        if (previewStepTimer) window.clearTimeout(previewStepTimer);
        previewTimer = null;
        previewStepTimer = null;
        delete carousel.dataset.previewing;
      };

      const cancelLongPressDetection = () => {
        if (longPressTimer) window.clearTimeout(longPressTimer);
        longPressTimer = null;
      };

      const setActive = () => {
        const width = track.clientWidth || 1;
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
        slides.forEach((slide, slideIndex) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (slideIndex === index && !document.hidden) {
            video.muted = true;
            video.play?.().then(() => slide.classList.add('is-playing')).catch(() => slide.classList.remove('is-playing'));
          } else {
            video.pause();
            slide.classList.remove('is-playing');
          }
        });
      };

      const requestActiveUpdate = () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(setActive);
      };

      const goToSlide = (index) => {
        const normalizedIndex = (index + slides.length) % slides.length;
        track.scrollTo({ left: normalizedIndex * track.clientWidth, behavior: 'smooth' });
      };

      const previewRemainingSlides = (delay = 500) => {
        if (slides.length < 2 || document.hidden) return;
        stopLongPressPreview();
        document.dispatchEvent(new CustomEvent('rwatches:stop-product-card-previews', { detail: { carousel } }));
        carousel.dataset.previewing = 'true';
        previewTimer = window.setTimeout(() => {
          const next = () => {
            const width = track.clientWidth || 1;
            const currentIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
            goToSlide(currentIndex + 1);
            previewStepTimer = window.setTimeout(next, 1050);
          };
          next();
        }, delay);
      };

      const beginDrag = (clientX, clientY) => {
        stopLongPressPreview();
        cancelLongPressDetection();
        startX = clientX;
        startY = clientY;
        startScrollLeft = track.scrollLeft;
        didDrag = false;
      };

      const updateDrag = (clientX, clientY) => {
        const deltaX = clientX - startX;
        const deltaY = clientY - startY;
        if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
          didDrag = true;
          carousel.dataset.dragging = 'true';
          cancelLongPressDetection();
        }
        return didDrag;
      };

      const finishDrag = (clientX) => {
        if (!didDrag) return false;
        const deltaX = clientX - startX;
        const startIndex = Math.round(startScrollLeft / (track.clientWidth || 1));
        if (Math.abs(deltaX) > 24) {
          goToSlide(startIndex + (deltaX < 0 ? 1 : -1));
        }
        window.setTimeout(() => {
          delete carousel.dataset.dragging;
          didDrag = false;
        }, 120);
        return true;
      };

      track.addEventListener('scroll', requestActiveUpdate, { passive: true });
      carousel.addEventListener('pointerdown', (event) => {
        if (touchStarted) return;
        beginDrag(event.clientX, event.clientY);
        carousel.setPointerCapture?.(event.pointerId);
      }, { passive: true });
      carousel.addEventListener('pointermove', (event) => {
        if (touchStarted) return;
        updateDrag(event.clientX, event.clientY);
      }, { passive: true });
      carousel.addEventListener('pointerup', (event) => {
        if (touchStarted) return;
        finishDrag(event.clientX);
      }, { passive: true });
      carousel.addEventListener('pointercancel', () => {
        delete carousel.dataset.dragging;
        didDrag = false;
      }, { passive: true });
      carousel.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        touchStarted = true;
        beginDrag(touch.clientX, touch.clientY);
      }, { passive: true });
      carousel.addEventListener('touchmove', (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        if (updateDrag(touch.clientX, touch.clientY)) {
          event.preventDefault();
        }
      }, { passive: false });
      carousel.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        cancelLongPressDetection();
        if (touch) finishDrag(touch.clientX);
        window.setTimeout(() => {
          touchStarted = false;
        }, 40);
      }, { passive: true });
      carousel.addEventListener('touchcancel', () => {
        cancelLongPressDetection();
        touchStarted = false;
        delete carousel.dataset.dragging;
        didDrag = false;
      }, { passive: true });
      carousel.addEventListener('click', (event) => {
        if (carousel.dataset.dragging === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
      document.addEventListener('rwatches:stop-product-card-previews', (event) => {
        if (event.detail?.carousel === carousel) return;
        stopLongPressPreview();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopLongPressPreview();
          slides.forEach((slide) => slide.querySelector('video')?.pause());
          return;
        }
        setActive();
      });
      setActive();
    });
  }

  function setProductGalleryMedia(gallery, mediaId, shouldPlay) {
    if (!gallery || !mediaId) return;
    gallery.querySelectorAll('[data-product-media]').forEach((panel) => {
      const isActive = panel.dataset.productMedia === mediaId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
      panel.querySelectorAll('video').forEach((video) => {
        if (isActive && shouldPlay && !document.hidden) {
          video.removeAttribute('muted');
          video.defaultMuted = false;
          video.muted = false;
          video.volume = 1.0;
          const playPromise = video.play?.();
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              video.muted = true;
              video.play?.().catch(() => {});
            });
          }
        } else {
          video.pause();
        }
      });
    });
    gallery.querySelectorAll('[data-product-thumb]').forEach((button) => {
      const isActive = button.dataset.mediaId === mediaId;
      if (isActive) {
        button.setAttribute('aria-current', 'true');
        button.scrollIntoView?.({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function initProductGallerySlider(root) {
    const scope = root || document;
    scope.querySelectorAll('.product-gallery:not([data-gallery-slider-ready])').forEach((gallery) => {
      const panels = Array.from(gallery.querySelectorAll('[data-product-media]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
      if (panels.length < 2 || !thumbs.length) return;
      gallery.dataset.gallerySliderReady = 'true';
      const mediaArea = gallery.querySelector('.product-main-media') || gallery;
      let startX = 0;
      let startY = 0;
      let didDrag = false;

      const activeIndex = () => Math.max(0, panels.findIndex((panel) => panel.classList.contains('is-active')));

      const goToMedia = (index) => {
        const normalizedIndex = (index + panels.length) % panels.length;
        setProductGalleryMedia(gallery, panels[normalizedIndex].dataset.productMedia, true);
      };

      mediaArea.addEventListener('pointerdown', (event) => {
        if (event.target.closest('button, a')) return;
        startX = event.clientX;
        startY = event.clientY;
        didDrag = false;
        mediaArea.setPointerCapture?.(event.pointerId);
      }, { passive: true });
      mediaArea.addEventListener('pointermove', (event) => {
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
          didDrag = true;
          gallery.dataset.galleryDragging = 'true';
        }
      }, { passive: true });
      mediaArea.addEventListener('pointerup', (event) => {
        if (!didDrag) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        if (Math.abs(deltaX) > 32 && Math.abs(deltaX) > Math.abs(deltaY)) {
          goToMedia(activeIndex() + (deltaX < 0 ? 1 : -1));
        }
        didDrag = false;
        window.setTimeout(() => {
          delete gallery.dataset.galleryDragging;
        }, 120);
      }, { passive: true });
      mediaArea.addEventListener('pointercancel', () => {
        didDrag = false;
        delete gallery.dataset.galleryDragging;
      }, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          panels.forEach((panel) => panel.querySelector('video')?.pause());
        }
      });
    });
  }

  function initInfiniteProductGrids() {
    const grids = Array.from(document.querySelectorAll('[data-infinite-grid]'));
    if (!grids.length) return;

    if ('scrollRestoration' in window.history) {
      try {
        window.history.scrollRestoration = 'manual';
      } catch (e) {}
    }

    grids.forEach((grid) => {
      const controls = grid.parentElement?.querySelector('[data-infinite-controls]') || document.querySelector('[data-infinite-controls]');
      if (!controls) return;
      const button = controls.querySelector('[data-infinite-button]');
      const status = controls.querySelector('[data-infinite-status]');

      // Seamless infinite scroll: hide manual button from normal UX
      if (button) button.style.display = 'none';

      let isLoading = false;
      let hasMore = true;
      let loadGeneration = 0;
      let abortController = null;
      let observer = null;

      const disconnectObserver = () => {
        hasMore = false;
        isLoading = false;
        grid.dataset.loading = 'false';
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        if (controls) {
          controls.setAttribute('hidden', 'true');
          controls.style.display = 'none';
        }
        if (status) status.textContent = '';
        if (button) button.style.display = 'none';
      };
      window.rwDisconnectInfiniteObserver = disconnectObserver;

      const reconnectObserver = () => {
        hasMore = true;
        if (controls) {
          controls.removeAttribute('hidden');
          controls.style.display = '';
        }
        if (status) status.textContent = '';
        if (button) button.style.display = 'none';
        if (!observer && 'IntersectionObserver' in window && controls) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                fetchNextPage();
              }
            });
          }, { rootMargin: '650px 0px' });
          observer.observe(controls);
        }
      };
      window.rwReconnectInfiniteObserver = reconnectObserver;

      const fetchNextPage = async () => {
        if (isLoading || !hasMore || grid.dataset.loading === 'true' || grid.dataset.loadingAll === 'true') return;

        const isFiltered = grid.getAttribute('data-filtered-rendered') === 'true' ||
          (typeof window.rwIsFiltered === 'function' && window.rwIsFiltered());

        // --- 1. FILTERED SCOPE: Render next batch of filtered products strictly ---
        if (isFiltered) {
          if (typeof window.rwLoadMoreFiltered === 'function') {
            isLoading = true;
            grid.dataset.loading = 'true';
            window.rwLoadMoreFiltered();
            isLoading = false;
            grid.dataset.loading = 'false';
          }
          return;
        }

        // --- 2. UNFILTERED SERVER SCOPE: Load next page preserving active params ---
        const nextUrl = grid.dataset.nextUrl;
        if (!nextUrl) {
          disconnectObserver();
          return;
        }

        isLoading = true;
        grid.dataset.loading = 'true';
        if (status) status.textContent = '';

        const thisGen = ++loadGeneration;
        if (abortController) abortController.abort();
        abortController = new AbortController();

        try {
          const nextUrlObj = new URL(nextUrl, window.location.origin);
          const curUrlParams = new URLSearchParams(window.location.search);
          curUrlParams.forEach((val, key) => {
            if (key !== 'page' && !nextUrlObj.searchParams.has(key)) {
              nextUrlObj.searchParams.set(key, val);
            }
          });

          const response = await fetch(nextUrlObj.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: abortController.signal
          });
          if (!response.ok) throw new Error('Fetch failed with status ' + response.status);
          const html = await response.text();

          // Race condition safeguard: discard if filter changed while request was in-flight
          if (thisGen !== loadGeneration || grid.getAttribute('data-filtered-rendered') === 'true' ||
              (typeof window.rwIsFiltered === 'function' && window.rwIsFiltered())) {
            return;
          }

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector(`[data-infinite-id="${grid.dataset.infiniteId}"]`) || doc.querySelector('[data-infinite-grid]');
          if (!nextGrid) {
            disconnectObserver();
            return;
          }

          const existingIds = new Set(
            Array.from(grid.querySelectorAll('[data-product-card]'))
              .map(c => c.dataset.productHandle || c.dataset.productId)
              .filter(Boolean)
          );

          const incomingCards = Array.from(nextGrid.querySelectorAll('[data-product-card]'));
          incomingCards.forEach((card) => {
            const cardId = card.dataset.productHandle || card.dataset.productId;
            if (cardId && existingIds.has(cardId)) return; // Strict duplicate prevention
            if (cardId) existingIds.add(cardId);
            card.dataset.originalIndex = String(grid.querySelectorAll('[data-product-card]').length);
            grid.appendChild(card);
          });

          if (typeof initProductCardCarousels === 'function') {
            initProductCardCarousels(grid);
          }
          document.dispatchEvent(new CustomEvent('rwatches:products-loaded'));

          const nextNextUrl = nextGrid.dataset.nextUrl || '';
          grid.dataset.nextUrl = nextNextUrl;

          if (!nextNextUrl) {
            // TERMINAL STATE: No more pages from server
            disconnectObserver();
          } else {
            if (status) status.textContent = '';
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            disconnectObserver();
          }
        } finally {
          isLoading = false;
          grid.dataset.loading = 'false';
        }
      };

      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          fetchNextPage();
        });
      }

      // Initial state evaluation
      const initialIsFiltered = grid.getAttribute('data-filtered-rendered') === 'true' ||
        (typeof window.rwIsFiltered === 'function' && window.rwIsFiltered());
      if (!initialIsFiltered && !grid.dataset.nextUrl) {
        disconnectObserver();
      } else {
        reconnectObserver();
      }

      window.rwTriggerInfiniteLoad = fetchNextPage;
    });
  }

  function searchImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || image.transformedSrc || '';
  }

  function setSearchDefaults(form, show) {
    form.querySelector('[data-search-defaults]')?.toggleAttribute('hidden', !show);
    const target = document.querySelector(form.dataset.resultsTarget);
    if (target && show) target.innerHTML = '';
  }

  function searchCatalogProducts(rawQuery) {
    if (!rawQuery || String(rawQuery).trim().length < 2) return [];
    const index = (window.RW_FILTER_INDEX && window.RW_FILTER_INDEX.products) || (window.RW_PREVIEW_CATALOG && window.RW_PREVIEW_CATALOG.products) || [];
    if (!index.length) return [];
    const cleanQuery = String(rawQuery).replace(/\*/g, '').replace(/\bAND\b/gi, ' ').trim();
    const queryTerm = normalize(cleanQuery);
    const queryWords = queryTerm.split(/[\s-]+/).filter(function(w) {
      return Boolean(w) && w !== 'and' && w !== 'or';
    });
    if (!queryWords.length) return [];

    const matches = [];
    for (let i = 0; i < index.length; i++) {
      const p = index[i];
      const sStr = p._searchStr || (normalize(p.title || '') + ' ' + normalize(p.vendor || '') + ' ' + (p.categories || []).map(c => normalize(c.title || '') + ' ' + normalize(c.handle || '')).join(' '));
      let matched = true;
      for (let j = 0; j < queryWords.length; j++) {
        if (!sStr.includes(queryWords[j])) {
          matched = false;
          break;
        }
      }
      if (matched) {
        matches.push({
          title: p.title,
          url: safeProductUrl(p),
          image: p.image || (Array.isArray(p.images) ? p.images[0] : ''),
          vendor: p.vendor || 'R WATCHES NGP',
          category: p.categories?.[0]?.title || p.vendor || ''
        });
        if (matches.length >= 20) break;
      }
    }
    return matches;
  }

  function renderSearchItems(items) {
    return `
      <div class="predictive-results__heading">Showing products</div>
      ${items.map((item) => {
        const image = searchImageUrl(item.image);
        const category = item.category || item.product_type || item.vendor || '';
        return `
          <a class="predictive-result-card" href="${escapeHtml(item.url)}">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.title)}">` : '<span></span>'}
            <span class="predictive-result-card__info">
              <strong>${escapeHtml(item.title)}</strong>
              ${category ? `<small>In ${escapeHtml(category).toUpperCase()}</small>` : ''}
            </span>
            <span class="predictive-result-card__arrow" aria-hidden="true">&rarr;</span>
          </a>
        `;
      }).join('')}
    `;
  }

  let activeSearchController = null;
  let searchDebounceTimer = null;

  function predictiveSearch(form) {
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    const target = document.querySelector(form.dataset.resultsTarget);
    const clear = form.querySelector('[data-search-clear]');
    const rawValue = input?.value || '';
    const query = rawValue.trim();

    if (clear) clear.hidden = !query;

    // Strict Rule: When input is cleared or less than 2 chars, reset to defaults and NEVER show all products
    if (!input || !target || query.length < 2) {
      if (searchDebounceTimer) clearTimeout(searchDebounceTimer);
      if (activeSearchController) {
        activeSearchController.abort();
        activeSearchController = null;
      }
      setSearchDefaults(form, true);
      return;
    }

    setSearchDefaults(form, false);

    if (searchDebounceTimer) clearTimeout(searchDebounceTimer);
    if (activeSearchController) {
      activeSearchController.abort();
      activeSearchController = null;
    }

    searchDebounceTimer = setTimeout(async () => {
      const currentQuery = input.value.trim();
      if (currentQuery.length < 2) {
        setSearchDefaults(form, true);
        return;
      }

      target.innerHTML = '<p class="predictive-results__status">Searching...</p>';

      // Fetch directly from Shopify live suggest API with cancellation safety
      activeSearchController = new AbortController();
      const url = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(currentQuery)}&resources[type]=product&resources[limit]=20`;

      try {
        const response = await fetch(url, { signal: activeSearchController.signal });
        if (!response.ok) return;
        const data = await response.json();
        const apiProducts = data.resources?.results?.products || [];

        // Verify current query hasn't changed while request was in flight
        if (input.value.trim() !== currentQuery) return;

        if (apiProducts.length) {
          target.innerHTML = renderSearchItems(apiProducts);
        } else {
          target.innerHTML = '<p class="predictive-results__status">No products found.</p>';
        }
      } catch (err) {
        if (err.name === 'AbortError') return;
        if (input.value.trim() === currentQuery) {
          target.innerHTML = '<p class="predictive-results__status">No products found.</p>';
        }
      }
    }, 120);
  }

  document.addEventListener('click', (event) => {
    const productAnchor = event.target.closest('a[href*="/products/"]');
    if (productAnchor) {
      const rawHref = productAnchor.getAttribute('href');
      if (rawHref && (rawHref.includes('%25') || rawHref.includes('%2525'))) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = safeProductUrl(rawHref);
        return;
      }
    }

    const trigger = event.target.closest(selectors.drawerTrigger);
    if (trigger) {
      event.preventDefault();
      openDrawer(trigger.dataset.drawerTrigger);
    }
    const shareViewButton = event.target.closest('[data-share-current-view]');
    if (shareViewButton) {
      event.preventDefault();
      shareCurrentView();
      return;
    }
    const shareButton = event.target.closest('[data-product-share]');
    if (shareButton) {
      event.preventDefault();
      shareProduct(shareButton);
      return;
    }
    const clearSearch = event.target.closest('[data-search-clear]');
    if (clearSearch) {
      event.preventDefault();
      const form = clearSearch.closest('[data-predictive-search]');
      const input = form?.querySelector('input[name="q"]');
      if (input) {
        input.value = '';
        predictiveSearch(form);
        input.focus();
      }
      return;
    }
    const recentTerm = event.target.closest('[data-search-term]');
    if (recentTerm) {
      event.preventDefault();
      const term = (recentTerm.dataset.searchTerm || recentTerm.textContent || '').trim();
      if (!term) return;
      const form = recentTerm.closest('[data-predictive-search]');
      const input = form?.querySelector('input[name="q"]');
      if (input) {
        input.value = term;
      }
      const searchBaseUrl = form?.getAttribute('action') || (window.Shopify?.routes?.root || '/') + 'search';
      const targetUrl = new URL(searchBaseUrl, window.location.origin);
      targetUrl.searchParams.set('q', term);
      targetUrl.searchParams.set('type', 'product');
      targetUrl.searchParams.set('options[prefix]', 'last');
      window.location.href = targetUrl.toString();
      return;
    }
    const clearRecent = event.target.closest('[data-search-clear-recent]');
    if (clearRecent) {
      event.preventDefault();
      clearRecent.closest('.recent-searches')?.setAttribute('hidden', '');
      return;
    }
    if (event.target.closest('[data-coupon-open]')) {
      event.preventDefault();
      event.stopPropagation();
      openCouponModal();
      return;
    }
    if (event.target.closest('[data-coupon-close]')) {
      event.preventDefault();
      closeCouponModal();
      return;
    }
    const cartBack = event.target.closest('[data-cart-back]');
    if (cartBack) {
      event.preventDefault();
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = window.Shopify.routes.root;
      }
      return;
    }
    const priceDetails = event.target.closest('[data-scroll-price-details]');
    if (priceDetails) {
      event.preventDefault();
      const target = document.querySelector('#CartDrawer .cart-summary, #CartPriceDetails');
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (event.target.closest(selectors.drawerClose) || event.target.matches(selectors.backdrop)) {
      event.preventDefault();
      closeDrawer();
    }
    const drawerLink = event.target.closest('.drawer a[href]');
    if (drawerLink && activeDrawer && (!drawerLink.target || drawerLink.target === '_self')) {
      if (isSamePageAnchor(drawerLink)) {
        window.setTimeout(closeDrawer, 0);
      } else {
        closeDrawer();
      }
    }
    const quantityButton = event.target.closest('[data-cart-quantity]');
    if (quantityButton) {
      event.preventDefault();
      updateCart(quantityButton.dataset.line, quantityButton.dataset.quantity);
    }
    const thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      const targetMediaId = thumb.dataset.mediaId;
      const gallery = thumb.closest('.product-gallery');
      if (!targetMediaId || !gallery) return;
      setProductGalleryMedia(gallery, targetMediaId, true);
      return;
    }
    const productPanel = event.target.closest('.product-media-panel.is-active');
    const productGallery = productPanel?.closest('.product-gallery');
    if (productPanel && productGallery && !productGallery.dataset.galleryDragging && !event.target.closest('button, a, video')) {
      event.preventDefault();
      openProductLightbox(productGallery, productPanel.dataset.productMedia);
    }
  });

  document.addEventListener('click', (event) => {
    if (!activeLightbox) return;
    if (event.target.closest('[data-lightbox-close]') || event.target === activeLightbox.element) {
      event.preventDefault();
      closeProductLightbox();
      return;
    }
    const direction = event.target.closest('[data-lightbox-direction]');
    if (direction) {
      event.preventDefault();
      renderProductLightbox(activeLightbox.index + Number(direction.dataset.lightboxDirection || 0));
      return;
    }
    const lightboxThumb = event.target.closest('[data-lightbox-thumb]');
    if (lightboxThumb) {
      event.preventDefault();
      renderProductLightbox(Number(lightboxThumb.dataset.lightboxThumb || 0));
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const submit = event.submitter || form.querySelector('[type="submit"]');
    form.querySelectorAll('[data-price-choice]').forEach((input) => {
      input.disabled = true;
    });
    form.querySelectorAll('[data-price-min-field], [data-price-max-field]').forEach((input) => {
      input.disabled = input.value === '';
    });
    if (form.matches('[data-product-form]') && submit?.dataset.goToCart === 'true') {
      event.preventDefault();
      openDrawer('CartDrawer');
      return;
    }
    if (submit?.hasAttribute('data-buy-now')) {
      return;
    }
    if (submit?.name === 'checkout') {
      if (submit?.hasAttribute('data-checkout-direct')) {
        event.preventDefault();
        submit?.classList.add('is-loading');
        submit?.setAttribute('disabled', 'disabled');
        goDirectlyToCheckout(form);
        return;
      }
      persistCheckoutDiscount(form);
      submit?.classList.add('is-loading');
      submit?.setAttribute('disabled', 'disabled');
      return;
    }
    if (form.matches('[data-coupon-form]')) {
      event.preventDefault();
      applyDiscountCode(form, submit);
      return;
    }
    if (form.matches('[data-predictive-search]') || form.matches('form[role="search"]') || form.getAttribute('action')?.includes('/search')) {
      const input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) {
        event.preventDefault();
        return;
      }
      const raw = input.value.trim();
      const resolved = (typeof resolveSearchBrand === 'function')
        ? resolveSearchBrand(raw, window.RW_LIVE_COLLECTIONS)
        : null;
      if (resolved && (resolved.matchType === 'exact' || resolved.matchType === 'prefix')) {
        const targetBrand = resolved.brand || resolved.handle;
        input.value = targetBrand;
      } else {
        input.value = raw.replace(/\*/g, '').trim();
      }
    }
    if (form.matches('[data-ajax-cart-form]')) {
      event.preventDefault();
      addToCart(form, submit);
    }
  });

  document.addEventListener('input', (event) => {
    const form = event.target.closest('[data-predictive-search]');
    if (form) predictiveSearch(form);
  });

  document.addEventListener('change', (event) => {
    const quantitySelect = event.target.closest('[data-cart-quantity-select]');
    if (quantitySelect) {
      updateCart(quantitySelect.dataset.line, quantitySelect.value);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (activeLightbox) {
        closeProductLightbox();
      } else if (document.querySelector('[data-coupon-modal]:not([hidden])')) {
        closeCouponModal();
      } else {
        closeDrawer();
      }
    }
    if ((event.key === 'Enter' || event.key === ' ') && event.target.closest('[data-coupon-open]')) {
      event.preventDefault();
      openCouponModal();
    }
    if (activeLightbox && event.key === 'ArrowLeft') renderProductLightbox(activeLightbox.index - 1);
    if (activeLightbox && event.key === 'ArrowRight') renderProductLightbox(activeLightbox.index + 1);
    trapFocus(event);
  });

  renderPreviewGrids();
  function initWatchAndBuyCarousel() {
    const track = document.querySelector('[data-watch-buy-track]');
    if (!track || track.dataset.wbAutoInit === 'true') return;
    track.dataset.wbAutoInit = 'true';

    // Remove any scroll snapping that stops programmatic scroll
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';

    // Extract and randomly shuffle all available product cards
    const initialCards = Array.from(track.querySelectorAll('[data-wb-card]:not([data-wb-clone])'));
    if (initialCards.length > 1) {
      for (let i = initialCards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [initialCards[i], initialCards[j]] = [initialCards[j], initialCards[i]];
      }
      track.innerHTML = '';
      initialCards.forEach((card) => track.appendChild(card));

      initialCards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-wb-clone', 'true');
        track.appendChild(clone);
      });
    }

    let isPaused = false;
    let resumeTimer = null;

    const pause = () => {
      isPaused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
    };

    const resume = (delay = 1200) => {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        isPaused = false;
      }, delay);
    };

    const speed = 0.5; // Smooth slow scroll matching other sections
    function step() {
      if (!isPaused && track.scrollWidth > track.clientWidth) {
        track.scrollLeft += speed;
        const half = track.scrollWidth / 2;
        if (half > 0 && track.scrollLeft >= half) {
          track.scrollLeft -= half;
        }
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', () => resume(400));
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchmove', pause, { passive: true });
    track.addEventListener('touchend', () => resume(1200));

    // Mouse drag
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;
    let moved = false;

    track.addEventListener('mousedown', (e) => {
      if (e.target.closest('.wb-buy-btn')) return;
      isDragging = true;
      moved = false;
      pause();
      startX = e.pageX - track.offsetLeft;
      startScroll = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.userSelect = 'none';
    });

    window.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
        track.style.cursor = '';
        track.style.userSelect = '';
        resume(1200);
      }
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 4) moved = true;
      track.scrollLeft = startScroll - walk;
    });

    track.addEventListener('wheel', () => {
      pause();
      resume(1200);
    }, { passive: true });

    // Stream visible videos
    const videos = track.querySelectorAll('[data-wb-video]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const vid = entry.target;
          if (entry.isIntersecting) {
            if (!vid.src && vid.dataset.src) {
              vid.src = vid.dataset.src;
            }
            vid.play().catch(() => {});
          } else {
            vid.pause();
          }
        });
      }, { root: null, rootMargin: '100px', threshold: 0.1 });
      videos.forEach((v) => observer.observe(v));
    } else {
      videos.forEach((v) => {
        if (v.dataset.src) v.src = v.dataset.src;
        v.play().catch(() => {});
      });
    }

    // Modal click listeners
    track.querySelectorAll('[data-wb-card]').forEach((card) => {
      card.addEventListener('click', (e) => {
        if (moved || e.target.closest('.wb-buy-btn')) return;
        const title = card.dataset.productTitle || '';
        const url = card.dataset.productUrl || '';
        const price = card.dataset.productPrice || '';
        const compare = card.dataset.productCompare || '';
        const discount = card.dataset.productDiscount || '0';
        const thumb = card.dataset.productThumb || '';
        const videoUrl = card.dataset.videoUrl || card.dataset.videoPreview || '';
        const previewUrl = card.dataset.videoPreview || '';

        const cardVideoEl = card.querySelector('video');
        const cardVideoSrc = cardVideoEl ? (cardVideoEl.currentSrc || cardVideoEl.src) : '';

        if (typeof openWbReel === 'function') {
          openWbReel(title, url, price, compare, discount, thumb, videoUrl, previewUrl, cardVideoSrc);
        }
      });
    });
  }

  function shuffleSearchBrands() {
    const grids = document.querySelectorAll('[data-search-category-grid], [data-search-brand-grid]');
    grids.forEach((grid) => {
      const cards = Array.from(grid.children);
      if (cards.length <= 1) return;
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = cards[i];
        cards[i] = cards[j];
        cards[j] = temp;
      }
      const isDrawer = grid.hasAttribute('data-search-category-grid');
      cards.forEach((card, index) => {
        if (isDrawer) {
          card.style.display = index < 6 ? 'flex' : 'none';
        }
        grid.appendChild(card);
      });
    });
  }

  function triggerWhatsAppAnimation() {
    const container = document.querySelector('[data-whatsapp-container]');
    if (!container) return;
    const floatBtn = container.querySelector('[data-whatsapp-floating]');
    const popup = container.querySelector('[data-whatsapp-popup]');

    if (!floatBtn || !popup) return;
    if (document.hidden) return;

    // Step 2: Gentle Shake/Bounce for ~1.3 seconds
    floatBtn.classList.add('is-shaking');
    setTimeout(() => {
      floatBtn.classList.remove('is-shaking');
    }, 1300);

    // Step 3: Show "Need Help?" speech bubble popup
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');

    // Auto-dismiss popup after 4 seconds
    setTimeout(() => {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    }, 4000);
  }

  function initNotificationOrchestrator() {
    window.triggerJustBooked = triggerJustBookedFlash;
    window.triggerWhatsAppHelp = triggerWhatsAppAnimation;

    const container = document.querySelector('[data-whatsapp-container]');
    if (container) {
      const popup = container.querySelector('[data-whatsapp-popup]');
      const closeBtn = container.querySelector('[data-whatsapp-popup-close]');
      if (popup && closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          popup.classList.remove('is-visible');
          popup.setAttribute('aria-hidden', 'true');
        });
      }
    }

    const INTERVAL = 30000;
    const STORAGE_KEY = 'rw_last_notif_time';
    const PHASE_KEY = 'rw_notif_phase';

    let phase = parseInt(sessionStorage.getItem(PHASE_KEY) || '0', 10);
    if (isNaN(phase) || phase < 0 || phase > 1) phase = 0;

    function step() {
      const now = Date.now();
      sessionStorage.setItem(STORAGE_KEY, now.toString());
      if (phase === 0) {
        triggerJustBookedFlash();
        phase = 1;
      } else {
        triggerWhatsAppAnimation();
        phase = 0;
      }
      sessionStorage.setItem(PHASE_KEY, phase.toString());
    }

    const lastTimeStr = sessionStorage.getItem(STORAGE_KEY);
    const lastTime = lastTimeStr ? parseInt(lastTimeStr, 10) : 0;
    const elapsed = lastTime > 0 ? (Date.now() - lastTime) : INTERVAL;

    let initialDelay = INTERVAL;
    if (lastTime > 0) {
      if (elapsed < INTERVAL) {
        initialDelay = INTERVAL - elapsed;
      } else {
        initialDelay = 1000;
      }
    }

    setTimeout(() => {
      step();
      setInterval(step, INTERVAL);
    }, initialDelay);
  }

  function initImageAndVideoLongPressModal() {
    if (window._mediaLongPressInitialized) return;
    window._mediaLongPressInitialized = true;

    let pressTimer = null;
    let startX = 0;
    let startY = 0;
    let longPressFired = false;
    let modalOpenedAt = 0;

    const clearSelection = () => {
      try {
        if (window.getSelection) {
          const sel = window.getSelection();
          if (sel && sel.removeAllRanges) sel.removeAllRanges();
        }
      } catch (_) {}
    };

    const removeModals = () => {
      clearSelection();
      document.querySelectorAll('.media-options-modal').forEach((el) => el.remove());
    };

    const isEligibleInteraction = () => {
      return (Date.now() - modalOpenedAt) > 350;
    };

    const showMediaOptionsModal = (details) => {
      removeModals();
      if (!details || !details.originalUrl) return;

      modalOpenedAt = Date.now();
      clearSelection();

      const modal = document.createElement('div');
      modal.className = 'media-options-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');

      const isVideo = details.type === 'video';
      const ext = isVideo ? 'mp4' : 'jpg';

      modal.innerHTML = `
        <div class="media-options-dialog">
          <div class="media-options-header">
            <div class="media-options-thumb">
              ${isVideo ? `<video src="${escapeHtml(details.thumbUrl)}" muted loop></video>` : `<img src="${escapeHtml(details.thumbUrl)}" alt="">`}
            </div>
            <div class="media-options-title-wrap">
              <span class="media-options-title">${escapeHtml(details.title)}</span>
              <span class="media-options-subtitle">Full HD Master ${isVideo ? 'Video' : 'Image'} (Original Quality)</span>
            </div>
            <button type="button" class="media-options-close" data-close-modal aria-label="Close">&times;</button>
          </div>
          <div class="media-options-list" style="pointer-events: none;">
            <button type="button" class="media-option-item media-option-item--primary" data-action="download">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
              <span>Download Full HD ${isVideo ? 'Video' : 'Image'}</span>
            </button>
            <button type="button" class="media-option-item" data-action="share">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
              <span>Share Full HD on WhatsApp</span>
            </button>
            <button type="button" class="media-option-item" data-action="copy-image">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
              <span>Copy ${isVideo ? 'Video' : 'Image'}</span>
            </button>
            <button type="button" class="media-option-item" data-action="copy-link">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
              <span>Copy ${isVideo ? 'Video' : 'Image'} Link</span>
            </button>
            <button type="button" class="media-option-item" data-action="new-tab">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
              <span>Open in New Tab</span>
            </button>
          </div>
        </div>
      `;

      // Enable pointer events on the list after finger release cooldown
      const listEl = modal.querySelector('.media-options-list');
      setTimeout(() => {
        if (listEl) listEl.style.pointerEvents = 'auto';
      }, 300);

      modal.querySelector('[data-close-modal]').addEventListener('click', (e) => {
        if (!isEligibleInteraction()) return;
        removeModals();
      });

      modal.addEventListener('click', (e) => {
        if (!isEligibleInteraction()) return;
        if (e.target === modal) removeModals();
      });

      modal.querySelector('[data-action="download"]').addEventListener('click', (e) => {
        if (!isEligibleInteraction()) return;
        triggerFileDownload(details.originalUrl, details.title, ext);
        removeModals();
      });

      modal.querySelector('[data-action="share"]').addEventListener('click', async (e) => {
        if (!isEligibleInteraction()) return;
        try {
          if (navigator.share) {
            const res = await fetch(details.originalUrl, { mode: 'cors' });
            const blob = await res.blob();
            const file = new File([blob], `${(details.title || 'watch').toLowerCase().replace(/[^a-z0-9]+/g, '-')}.${ext}`, { type: blob.type || (isVideo ? 'video/mp4' : 'image/jpeg') });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              await navigator.share({
                title: details.title,
                files: [file]
              });
              removeModals();
              return;
            }
          }
        } catch(err) {}
        triggerFileDownload(details.originalUrl, details.title, ext);
        removeModals();
      });

      modal.querySelector('[data-action="copy-image"]').addEventListener('click', async (e) => {
        if (!isEligibleInteraction()) return;
        try {
          if (details.type === 'image' && window.ClipboardItem) {
            const res = await fetch(details.originalUrl);
            const blob = await res.blob();
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = URL.createObjectURL(blob);
            await new Promise((resolve, reject) => {
              img.onload = resolve;
              img.onerror = reject;
            });
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            canvas.toBlob(async (pngBlob) => {
              if (pngBlob) {
                try {
                  await navigator.clipboard.write([new ClipboardItem({ 'image/png': pngBlob })]);
                } catch(err) {
                  await navigator.clipboard.writeText(details.originalUrl);
                }
              } else {
                await navigator.clipboard.writeText(details.originalUrl);
              }
            }, 'image/png');
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(details.originalUrl);
          }
        } catch (err) {
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(details.originalUrl);
            }
          } catch (_) {}
        }
        removeModals();
      });

      modal.querySelector('[data-action="copy-link"]').addEventListener('click', async (e) => {
        if (!isEligibleInteraction()) return;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(details.originalUrl);
          }
        } catch (_) {}
        removeModals();
      });

      modal.querySelector('[data-action="new-tab"]').addEventListener('click', (e) => {
        if (!isEligibleInteraction()) return;
        window.open(details.originalUrl, '_blank');
        removeModals();
      });

      document.body.appendChild(modal);
    };

    const findMediaTarget = (el) => {
      if (!el) return null;
      if (el.closest('#wb-reels-modal, .wb-reels-dialog')) {
        return null;
      }
      return el.closest('img, video, .product-card__media, .product-media-panel, [data-product-media], .product-card, .product-card-top-selling, .customer-reviews__card, .hero-slide');
    };

    const getMediaDetails = (target) => {
      if (!target) return null;
      const img = target.tagName === 'IMG' ? target : target.querySelector('img');
      const video = target.tagName === 'VIDEO' ? target : target.querySelector('video');
      const card = target.closest('[data-wb-card], [data-product-card], .product-media-panel, .product-gallery, .product-card, .product-card-top-selling, .customer-reviews__card, .hero-slide') || target;
      
      const title = (
        card.dataset?.productTitle ||
        card.getAttribute?.('data-product-title') ||
        card.querySelector?.('.product-card__title a')?.textContent ||
        card.querySelector?.('.product-card__title')?.getAttribute?.('title') ||
        document.querySelector?.('h1.product-title, .product-title, .product__title')?.textContent ||
        img?.getAttribute?.('data-product-title') ||
        img?.alt ||
        card.querySelector?.('.wb-title, .product-title, .product-card__title, .product-card-top-selling__title, h1, h2, h3')?.textContent ||
        'r-watches-master'
      ).trim();

      if (video || target.closest('[data-wb-card], .wb-video-box, .product-card__video-wrap')) {
        const videoUrl = card.dataset?.originalVideo || card.dataset?.videoUrl || (video ? (video.dataset.originalVideo || video.dataset.src || video.src || video.querySelector('source')?.src) : '');
        const thumbUrl = video?.getAttribute('poster') || img?.src || '';
        return { type: 'video', title, originalUrl: videoUrl, thumbUrl: thumbUrl || videoUrl, target };
      }

      if (img || target.tagName === 'IMG') {
        const rawSrc = img?.dataset?.fullSrc || img?.currentSrc || img?.src || target.src || '';
        if (!rawSrc) return null;
        const originalUrl = getOriginalImageUrl(rawSrc);
        const thumbUrl = img?.currentSrc || img?.src || rawSrc;
        return { type: 'image', title, originalUrl, thumbUrl, target };
      }

      return null;
    };

    document.addEventListener('touchstart', (e) => {
      const target = findMediaTarget(e.target);
      if (!target) return;
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      longPressFired = false;
      if (pressTimer) clearTimeout(pressTimer);

      pressTimer = setTimeout(() => {
        const details = getMediaDetails(target);
        if (details && details.originalUrl) {
          longPressFired = true;
          clearSelection();
          try { if (navigator.vibrate) navigator.vibrate(40); } catch(e) {}
          showMediaOptionsModal(details);
        }
      }, 420);
    }, { passive: true });

    document.addEventListener('touchmove', (e) => {
      if (!pressTimer) return;
      const touch = e.touches[0];
      if (Math.abs(touch.clientX - startX) > 8 || Math.abs(touch.clientY - startY) > 8) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    }, { passive: true });

    document.addEventListener('touchend', () => {
      if (pressTimer) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
      if (longPressFired) {
        clearSelection();
        setTimeout(() => {
          longPressFired = false;
        }, 100);
      }
    }, { passive: true });

    document.addEventListener('touchcancel', () => {
      if (pressTimer) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
      longPressFired = false;
      clearSelection();
    }, { passive: true });

    document.addEventListener('contextmenu', (e) => {
      const target = findMediaTarget(e.target);
      if (!target) return;
      const details = getMediaDetails(target);
      if (details && details.originalUrl) {
        e.preventDefault();
        clearSelection();
        showMediaOptionsModal(details);
      }
    });

    document.addEventListener('selectstart', (e) => {
      if (e.target && findMediaTarget(e.target)) {
        e.preventDefault();
      }
    });
  }

  renderPreviewCategoryGrid();
  renderPreviewSearchCategories();
  renderPreviewSearchResults();
  syncStoredDiscountFromCart();
  shuffleSearchBrands();
  initProductOptions(document);
  initDeliveryCheckers(document);
  initDynamicCategoryFilters();
  initPriceChoices();
  initSortPages();
  initCollectionSorting();
  initProductCardCarousels(document);
  initProductGallerySlider(document);
  initCartRecommendationScroll();
  initInfiniteProductGrids();
  initWatchAndBuyCarousel();
  initNotificationOrchestrator();
  initImageAndVideoLongPressModal();
  // Instant Link Prefetching Engine (0ms perceived page transitions)
  function initInstantPagePrefetch() {
    if (window._instantPrefetchInitialized) return;
    window._instantPrefetchInitialized = true;

    const prefetchedUrls = new Set();
    const prefetchUrl = (url) => {
      if (!url || prefetchedUrls.has(url)) return;
      try {
        const parsed = new URL(url, window.location.href);
        if (parsed.origin !== window.location.origin) return;
        if (parsed.pathname === window.location.pathname) return;
        prefetchedUrls.add(url);

        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        link.as = 'document';
        document.head.appendChild(link);
      } catch (e) {}
    };

    let timer = null;
    document.addEventListener('mouseover', (e) => {
      const anchor = e.target.closest('a[href]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

      timer = setTimeout(() => prefetchUrl(href), 65);
    }, { passive: true });

    document.addEventListener('mouseout', () => {
      if (timer) clearTimeout(timer);
    }, { passive: true });

    document.addEventListener('touchstart', (e) => {
      const anchor = e.target.closest('a[href]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (href && !href.startsWith('#') && !href.startsWith('javascript:')) {
        prefetchUrl(href);
      }
    }, { passive: true });
  }

    document.addEventListener('change', (e) => {
    if (e?.target && e.target.matches && e.target.matches('input[data-max-limit], #ProductQuantity')) {
      const val = Number(e.target.value);
      if (val > MAX_ORDER_QUANTITY) {
        e.target.value = MAX_ORDER_QUANTITY;
        window.RW_showLimitWarning(`Maximum ${MAX_ORDER_QUANTITY} units allowed per order.`);
      } else if (val < 1 && e.target.value !== '') {
        e.target.value = 1;
      }
    }
  });
  initInstantPagePrefetch();

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      document.querySelectorAll('button[name="checkout"], input[name="checkout"], [data-checkout-direct]').forEach(btn => {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
      });
    }
  });

  const searchInputs = document.querySelectorAll('input[name="q"]');
  searchInputs.forEach(input => {
    if (input.value && (input.value.includes('*') || input.value.includes('AND'))) {
      input.value = input.value.replace(/\*/g, '').replace(/\bAND\b/gi, ' ').replace(/\s+/g, ' ').trim();
    }
  });

})();
